import { MentorumYonetim } from "./MentorumYonetim";
import { MentorumRisk } from "./MentorumRisk";
import { MentorumKayitlar } from "./MentorumKayitlar";
import { mentorumModulDurumuSemasi } from "@koclukpanel/contracts";
import { onayBilgisi } from "./onay-kilidi-durumu";
import { OnayKilidi } from "./OnayKilidi";
import { useCallback, useEffect, useState, type ReactNode } from "react";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  BosDurum,
  Buton,
  Ikon,
  Iskelet,
  Kart,
  NotKutusu,
  SatirDugmesi,
  SatirMetni,
  marka,
} from "@koclukpanel/ui";
import { Kabuk, type MenuOgesi } from "./Kabuk";
import { AlanSekmeleri } from "./AlanSekmeleri";
import { alanOf, gorunurAlanlar, MENU_GRUPLARI } from "./menu-alanlari";
import { Mesajlar } from "./Mesajlar";
import { Personel360 } from "./personel360/Personel360";
import { PersonelSecici } from "./personel360/PersonelSecici";
import { MesajDenetim } from "./MesajDenetim";
import { Gorunum, GorunumSeridi } from "./Gorunum";
import { BildirimSablonlari } from "./BildirimSablonlari";
import { OyunYonetimi } from "./OyunYonetimi";
import { CanliCalisma } from "./CanliCalisma";
import { CanliBilgilendirme } from "./CanliBilgilendirme";
import { CANLI_MODUL_ANAHTARI } from "./canli-calisma";
import { YoneticiBugun } from "./YoneticiBugun";
import { Bekleyenler } from "./Bekleyenler";
import { Entegrasyonlar } from "./Entegrasyonlar";
import { Giris } from "./Giris";
import { JetonSayfasi } from "./JetonSayfasi";
import { AnketSayfasi } from "./AnketSayfasi";
import { Personel } from "./Personel";
import { Hesabim } from "./Hesabim";
import { OgrenciSecici, sonOgrenciyiYaz } from "./OgrenciSecici";
import { SistemSagligi } from "./SistemSagligi";
import { KoclukGorusmeleri } from "./KoclukGorusmeleri";
import { Mufredat } from "./Mufredat";
import { KaynakHavuzu } from "./KaynakHavuzu";
import { KonuPlani } from "./KonuPlani";
import { HaftalikAnaliz } from "./HaftalikAnaliz";
import { OgrenciKaynaklari } from "./OgrenciKaynaklari";
import { Bildirimler, BildirimZili } from "./Bildirimler";
import { bildirimHedefi } from "./bildirim-yonlendirme";
import { HataSiniri } from "./HataSiniri";
import { BaglantiBandi } from "./BaglantiBandi";
import {
  BakimModu,
  CikisYapildi,
  Hata403,
  Hata404,
  HesapKilitli,
  OturumSuresiDoldu,
  SifremiUnuttum,
} from "./SistemSayfalari";
import { KonuIlerlemesi } from "./KonuIlerlemesi";
import { OgrenciPlanlari } from "./OgrenciPlanlari";
import { ProgramGirisi } from "./ProgramGirisi";
import { HataDefteri } from "./HataDefteri";
import { KarneDosyaSekmesi } from "./Karne";
import { OgrenciDosyasi } from "./OgrenciDosyasi";
import { Ogrenci360 } from "./ogrenci360/Ogrenci360";
import { DenemeTanim } from "./DenemeTanim";
import { jetonSayfasiCozumle } from "@koclukpanel/contracts";
import { ANA_EKRAN, ekranYolu, yoldanEkran } from "./adres";
import { IsListesi } from "./IsListesi";
import { Program } from "./Program";
import { Raporlar } from "./Raporlar";
import { EksikVeliRaporlari } from "./EksikVeliRaporlari";
import { OnayKuyrugu } from "./OnayKuyrugu";
import { Adaylar } from "./Adaylar";
import { Takvim } from "./Takvim";
import { Operasyon } from "./Operasyon";
import { Notlarim } from "./Notlarim";
import { Talepler } from "./Talepler";
import { Gorusmeler } from "./Gorusmeler";
import { AbonelikKarti, Finans } from "./Finans";
import { Kvkk } from "./Kvkk";
import { YenilemeRiski } from "./YenilemeRiski";
import { Loglar } from "./Loglar";
import { Roller } from "./Roller";
import { DenemeGirisi, Denemeler } from "./Denemeler";
import { Ogrenciler } from "./Ogrenciler";
import { Yardim } from "./Yardim";
import { Tur } from "./Tur";
import { Etkinlik } from "./Etkinlik";
import { TeknikKonsol } from "./TeknikKonsol";
import { Yedek } from "./Yedek";
import { GeriYukleme } from "./GeriYukleme";
import { Guvenlik } from "./Guvenlik";
import { KurtarmaYordami } from "./KurtarmaYordami";
import { YedekBandi } from "./YedekBandi";
import {
  api,
  bakimDurumu,
  benGetir,
  canliModulDurumu,
  cikisYap,
  ikiAsamaDurum,
  kendiProfilim,
  type Ben,
} from "./api";
import { IKI_ASAMA_UYARISI, ertele, ertelemeSuruyorMu } from "./uyari-erteleme";
import type { PermissionCode } from "@koclukpanel/authz";
import { biriVarMi, izinSorgusu, izinVarMi } from "./izin";
import { IS_TURU_EKRANI } from "./is-turu-ekrani";

/**
 * Bir OGRENCI baglaminda calisan ekranlar.
 *
 * Bunlar arasinda gecerken secili ogrenci KORUNUYOR. Her menu
 * degisiminde sifirlansaydi uzman, ogrencinin programini hazirladiktan
 * sonra ayni ogrencinin raporuna gecemez; is listesine donup o
 * ogrencinin baska bir satirini bulmak zorunda kalirdi — ve o satir
 * yoksa rapor ekranina hic ulasamazdi.
 */
const OGRENCI_EKRANLARI: readonly string[] = [
  "ogrenci-360",
  "program",
  "raporlar",
  "denemeler",
  "abonelik",
  "kocluk",
  "konular",
  "dosya",
  "hata-defteri",
  /*
    UI/UX Dalga 1 (mutabakat K1/F02): bu dort ekran listede yoktu. Menuden
    gecince secim temizleniyordu; kanitta kocun program -> haftalik analiz
    -> veli raporu akisinda rapor BASKA bir ogrenciyle acildi. Listeyi
    elle tutmak bu yuzden riskli — is-turu-ekrani.test.ts'teki bekci,
    `aktif === <ekran> && (ogrenci ? ...)` bicimindeki her ekranin burada
    olmasini istiyor.
  */
  "ogrenci-kaynak",
  "haftalik-analiz",
  "ogrenci-planlari",
  "konu-plani",
];

/**
 * Menu. Her oge bir izne bagli ve kullanicinin COZULMUS yetkisine gore
 * suzuluyor — ama bu yalnizca GORSEL kolayliktir; asil kontrol her
 * istekte sunucuda yapiliyor (CLAUDE.md kural 1).
 *
 * Menuyu gizlemek bir guvenlik onlemi DEGIL: adresi bilen biri yine
 * istek atabilir ve sunucu onu reddeder. Menu suzmesinin amaci
 * kullaniciya kullanamayacagi seyleri gostermemek.
 */
const ODUL_MENU_IZINLERI = [
  "oyun.kural.goruntule",
  "oyun.urun.yonet",
  "oyun.siparis.yonet",
  "oyun.siparis.kagit_onayla",
] as const;

/**
 * Koç Ödül Merkezi (sürüm 9a, Emre kararı 07.10.2026): koç YALNIZ GÖRÜR. Davet ve puan girdisi `oyun.hareket.goruntule`,
 * sipariş girdisi `oyun.siparis.goruntule` ile de açılır (koçta ASSIGNED; öğrenci/veli panele girmez, veli ikisini de
 * taşımaz). Çark ve Mağaza girdileri yönetim izinlerinde kalır: koç onları görmez.
 */
const ODUL_DAVET_PUAN_IZINLERI = [...ODUL_MENU_IZINLERI, "oyun.hareket.goruntule"] as const;
const ODUL_SIPARIS_IZINLERI = [...ODUL_MENU_IZINLERI, "oyun.siparis.goruntule"] as const;

export const MENU: readonly MenuOgesi[] = [
  {
    anahtar: "mentorum",
    ikon: "gorusme",
    etiket: "Mentörüm yönetimi",
    izin: [
      "mentorum.erisim.goruntule",
      "mentorum.erisim.yonet",
      "mentorum.icerik.yonet",
      "kvkk.riza.kagit_kaydet",
    ],
  },
  {
    anahtar: "mentorum-risk",
    ikon: "uyari",
    etiket: "Risk uyarıları",
    izin: "mentorum.risk.goruntule",
  },
  {
    anahtar: "mentorum-kayitlar",
    ikon: "defter",
    etiket: "Kayıtlar",
    izin: "mentorum.kayit.goruntule",
  },
  { anahtar: "bugun", ikon: "bugun", etiket: "Bugün", izin: undefined },
  /*
    MESAJLAR "Gunluk is" bolumunde ve BUGUN'un hemen ardinda: bekleyen
    bir mesaj, bekleyen bir gorev kadar zaman duyarli. Sistem bolumune
    koysaydik gunde bir kez bakilan bir yer olurdu ve kanalin var olma
    sebebi (kocuyla sorun yasayan ogrencinin ulasabilmesi) zayiflardi.

    Izin GORUNTULEME, YAZMA degil: yalnizca okuyabilen bir rol
    tanimlandigi gun (arsiv incelemesi yapan bir yonetici gibi) menuyu
    hic goremezdi. Yazma dugmesi ayrica `mesaj.yazisma.yaz` istiyor ve
    o kontrol sunucuda.
  */
  {
    anahtar: "mesajlar",
    ikon: "gorusme",
    etiket: "Mesajlar",
    izin: "mesaj.yazisma.goruntule",
  },
  {
    anahtar: "ogrenci-360",
    ikon: "ogrenci",
    etiket: "Öğrenci 360°",
    /*
      ================================================================
      EN GENIS DEGIL, EN DAR IZIN — VE BU BILEREK
      ================================================================
      Bu ekran on bir bolumu bir araya getiriyor ama menu girdisi
      yalnizca "ogrenciyi gorebiliyor mu" soruyor. Bolum bolum izin
      kontrolu ICERIDE, sekme kayit defterinde (`ogrenci360/sekmeler.tsx`)
      ve asil kontrol her ucun kendisinde.

      Menuyu en genis izne baglasaydik — ornegin finans iznine — yalnizca
      programa bakmasi gereken uzman ekrani hic goremezdi.
    */
    izin: "kisi.ogrenci.goruntule",
  },
  {
    anahtar: "program",
    ikon: "program",
    etiket: "Haftalık program",
    izin: "program.hafta.goruntule",
  },
  {
    anahtar: "ogrenciler",
    ikon: "ogrenci",
    etiket: "Öğrenciler",
    izin: "kisi.ogrenci.goruntule",
  },
  // AYRI menu: "Personel" bir YONETIM listesi (rol atama, arsivleme,
  // davet), bu ekran ise tek kisinin butun kaydini toplayan bir
  // GORUNUM. Tek menuye gomseydik, yalnizca bir kisinin kaydina
  // bakmak isteyen kullanici geri alinmasi zor eylemlerin arasinda
  // dolasirdi.
  {
    anahtar: "personel-360",
    ikon: "rol",
    etiket: "Personel 360°",
    izin: "kisi.personel.goruntule",
  },
  {
    anahtar: "personel",
    ikon: "rol",
    etiket: "Personel",
    // Goruntuleme izni yeten kisi menuyu gorur; EKLEME dugmesi ayrica
    // `kisi.personel.yonet` istiyor. Menuyu yonetme iznine baglasaydik,
    // ekibini yalnizca GORMESI gereken koordinator listeye hic
    // ulasamazdi.
    izin: "kisi.personel.goruntule",
  },
  {
    anahtar: "mufredat",
    ikon: "mufredat",
    etiket: "Müfredat",
    // Goruntuleme izni menuyu aciyor; DUZENLEME dugmeleri ayrica
    // `akademik.mufredat.duzenle` istiyor. Uzman mufredati gormeli —
    // programi ona gore yaziyor — ama degistirmemeli.
    izin: "akademik.mufredat.goruntule",
  },
  {
    anahtar: "kaynaklar",
    ikon: "mufredat",
    etiket: "Kaynak havuzu",
    // "Mufredat"tan AYRI: orasi KONU yapisi, burasi o konulari
    // calisirken kullanilan KITAPLAR. Izinleri de ayri —
    // `akademik.kaynak.goruntule` uzmanda da var cunku program
    // hazirlarken listeden secmesi gerekiyor (matris §5.3 ALL: R),
    // ama havuzu YONETMEK ayri izin.
    izin: "akademik.kaynak.goruntule",
  },
  {
    anahtar: "denemeler",
    ikon: "deneme",
    etiket: "Denemeler",
    izin: "deneme.sonuc.goruntule",
  },
  {
    anahtar: "dosya",
    ikon: "ogrenci",
    etiket: "Öğrenci dosyası",
    // Veli, uzman atamasi ve dosyalar tek ekranda: ucu de "bu ogrenci
    // kimin" sorusunun parcasi. "Ogrenciler" listesinden AYRI cunku
    // orasi COK ogrencinin listesi, burasi TEK ogrencinin kaydi.
    izin: "kisi.ogrenci.goruntule",
  },
  {
    anahtar: "konular",
    ikon: "mufredat",
    etiket: "Konu ilerlemesi",
    // "Mufredat"tan AYRI: orasi KURUMUN mufredati (alan, ders, unite,
    // konu, surum), burasi TEK OGRENCININ o mufredatta nerede oldugu.
    // Ikisini tek ekrana gomseydim, mufredati duzenleme izni olmayan
    // ama ogrencisini isaretlemesi gereken uzman ekrana hic
    // ulasamazdi — izinleri de farkli.
    /*
      ================================================================
      KAPI EKRANIN EN DAR IZNINE BAGLI — 12.09.2026, CANLIDA OLCULDU
      ================================================================
      Burasi `kisi.ogrenci.goruntule` idi ve YANLISTI: ekran UC sorgu
      atiyor, ikisi o izinle geciyor ama ucuncusu
      (`/ogrenciler/:id/mufredat`) `akademik.mufredat.ogrenci_listesi`
      istiyor. Finans ve Satis rolleri birinciyi tasiyip ikinciyi
      tasimiyor: menude oge goruluyor, ekran aciliyor, icerik geliyor
      ve uzerine "Bu islem icin yetkiniz yok" dusuyordu.
      Kullaniciya sistem BOZUK gibi gorunuyordu; oysa sunucu dogru
      calisiyordu, yanlis olan menunun vaadiydi.

      Cozum izni GENISLETMEK degildi: finansin ogrencinin konu
      ilerlemesine ihtiyaci yok, ve canli bir sistemde bir uyariyi
      susturmak icin yetki dagitmak yanlis yon. Kapi, ekranin en dar
      iznine baglandi.

      `izin` "EN AZ BIRI" mantiginda calisiyor, yani AND yazilamiyor —
      ama gerek de yok: canlida olculdu, `akademik.mufredat.
      ogrenci_listesi` tasiyan HER rolde `kisi.ogrenci.goruntule` de
      var. Dar olani yazmak ikisini birden istemekle ayni sonucu
      veriyor.

      Etkilenen: Finans Sorumlusu ve Satis Danismani ogeyi artik
      gormuyor. Akademik Koordinator, Operasyon Admini, PDR Uzmani ve
      Super Admin degismedi.
    */
    izin: "akademik.mufredat.ogrenci_listesi",
  },
  {
    anahtar: "ogrenci-kaynak",
    ikon: "mufredat",
    etiket: "Öğrenci kaynakları",
    // "Kaynak havuzu"ndan AYRI: orasi KURUMUN ortak kitap listesi,
    // burasi TEK OGRENCIYE atanmis kitaplar ve ilerlemesi. Izinleri de
    // ayri — havuzu goren herkes ogrencinin listesini gormemeli
    // (matris §5.3: havuz ALL: R, ogrenci listesi ASSIGNED).
    izin: "akademik.kaynak.ogrenci_listesi",
  },
  {
    anahtar: "haftalik-analiz",
    ikon: "rapor",
    etiket: "Haftalık analiz",
    // Uc dort baslikli bir analiz uretiyordu ve hicbir ekran
    // cagirmiyordu (04.09.2026). Uzman is listesinde "kim geride
    // kaldi" sorusunu goruyor; NEDEN geride kaldigi burada.
    izin: "analiz.ogrenci.goruntule",
  },
  {
    anahtar: "ogrenci-planlari",
    ikon: "takvim",
    etiket: "Öğrenci planları",
    // F-PPL-07b (04.10.2026, musteri revizesi 5): okul/dershane/ozel ders
    // saatleri. Program ekrani ayni kayitlari bilgi amacli gosteriyor.
    izin: "takvim.mesguliyet.goruntule",
  },
  {
    anahtar: "konu-plani",
    ikon: "mufredat",
    etiket: "Konu planı",
    // "Haftalik program"dan AYRI ufuk: program bir haftayi gun gun
    // planliyor, bu ekran "hangi konu ne zamana kadar" tutuyor
    // (F-CUR-08). Ayni menude durmalari kasitli — uzman ikisini
    // birlikte kullaniyor.
    izin: "akademik.plan.goruntule",
  },
  {
    anahtar: "bildirimler",
    ikon: "bekliyor",
    etiket: "Bildirimlerim",
    // KENDI bildirimleri — izne baglanmaz. Herkesin kendi gelen
    // kutusu var ve bir izin arkasina koymak, izni olmayan kisiye
    // GONDERILEN bildirimi gizlemek olurdu.
  },
  {
    anahtar: "hata-defteri",
    ikon: "deneme",
    etiket: "Hata defteri",
    // Ogrencinin YANLIS yaptigi sorular. "Denemeler"den AYRI: orasi
    // deneme sonucu analizi, burasi tek tek sorular ve uzman
    // aciklamasi. Ikisi ayni izinde degil — hata defteri kendi
    // iznini tasiyor ve ogrenci de yaziyor.
    izin: "calisma.hatadefteri.goruntule",
  },
  {
    anahtar: "deneme-tanim",
    ikon: "deneme",
    etiket: "Deneme tanımla",
    // AYRI menu — "Denemeler" ekrani OGRENCI bazli analiz. Bu ekran
    // kurumun denemelerini tanimliyor ve baska kisiler kullaniyor:
    // analize bakan uzmanda `deneme.sinav.yonet` YOK.
    izin: ["deneme.sinav.yonet", "deneme.sonuc.gir"],
  },
  {
    anahtar: "kocluk",
    ikon: "gorusme",
    etiket: "Koçluk görüşmeleri",
    // AYRI menu — "Tanisma gorusmeleri" CRM tarafi, aday icin.
    // Bu ekran KAYITLI OGRENCININ gorusmeleri ve korumali PDR notu
    // burada yasiyor.
    izin: "gorusme.kayit.goruntule",
  },
  {
    anahtar: "raporlar",
    ikon: "rapor",
    etiket: "Veli raporları",
    izin: "rapor.veli.olustur",
  },
  // Satis danismaninin gunluk ekrani. `crm.aday.goruntule` uzmanda YOK —
  // menu ona gorunmuyor (matris §5.2: uzman aday havuzuna erismiyor).
  {
    anahtar: "adaylar",
    ikon: "aday",
    etiket: "Adaylar",
    izin: "crm.aday.goruntule",
  },
  // AYRI menu — "Adaylar"in icine gomulemez: tanisma raporunu ONAYLAYAN
  // ACADEMIC_LEAD aday havuzuna erisemiyor (matris §5.2) ve oraya hic
  // ulasamazdi. Rapor YAZAN uzmanda da `crm.aday.goruntule` yok.
  {
    anahtar: "gorusmeler",
    ikon: "gorusme",
    etiket: "Tanışma görüşmeleri",
    izin: ["crm.gorusme.rapor", "crm.gorusme.onayla", "crm.gorusme.planla"],
  },
  // Kendi takvimi HERKESTE var (matris §5.12 SELF: RCUD); ekran icindeki
  // sekmeler kendi izinlerine gore ayrica kontrol ediliyor.
  {
    anahtar: "takvim",
    ikon: "takvim",
    etiket: "Takvim",
    izin: "takvim.kendi.yonet",
  },
  // Duyuru okuma matriste HERKESTE var; ekran icindeki gorev ve izin
  // sekmeleri kendi izinlerine gore ayrica davraniyor.
  {
    anahtar: "operasyon",
    ikon: "duyuru",
    etiket: "Duyuru ve görevler",
    izin: "operasyon.duyuru.goruntule",
  },
  /*
    NOTLARIM (sürüm 9a, UNİKOÇ "TeacherNotes") — kişinin KENDİ notları. İZNE BAĞLI DEĞİL:
    matris §5.6 kişisel notu yalnız yazana veriyor, izin kodu yok; uçlar `@KimlikGerekli`
    ve sahiplik sunucuda (`notlarim.service.ts`). `KIMLIK_YETERLI_EKRANLAR`da kayıtlı.
  */
  { anahtar: "notlarim", ikon: "duzenle", etiket: "Notlarım", izin: undefined },
  // Destek acma matriste HERKESTE; ekranin ogrenci talebi sekmesi
  // kendi izniyle ayrica davraniyor.
  {
    anahtar: "talepler",
    ikon: "talep",
    etiket: "Talepler",
    /*
      ================================================================
      KAPI, EKRANIN UCUYLA AYNI IZNI SORUYOR — 12.09.2026
      ================================================================
      Burasi `yardim.destek.olustur` idi: bir DESTEK izni. Ekranin
      cektigi uc (`GET /operasyon/talepler`) ise su ucundan BIRINI
      istiyor. Ikisinin ortak yani yoktu.

      Olculdu: Satis Danismani ve Teknik Yonetici destek iznini
      tasiyip talep izinlerinin hicbirini tasimiyor. Menude "Talepler"
      goruluyor, ekran aciliyor ve iki istek birden 403 donuyordu.

      Uctaki liste ile buradaki liste AYNI olmali; ayri yazilirsa biri
      guncellenince oteki sessizce eskir ve ayni hata geri gelir.
    */
    izin: ["operasyon.talep.olustur", "operasyon.talep.karara_bagla", "finans.talep.karara_bagla"],
  },
  // Yalnizca onay yetkisi olanda gorunuyor: uzmanda bu menu bos bir
  // liste acardi.
  // Iki sekme, iki ayri izin — biri digerini kapatmasin:
  // tahsilat kuyrugu `finans.tahsilat.goruntule`, paket listesi
  // `finans.paket.yonet` ile de aciliyor.
  {
    anahtar: "finans",
    ikon: "finans",
    etiket: "Finans",
    izin: ["finans.tahsilat.goruntule", "finans.paket.yonet"],
  },
  // OGRENCI baglaminda acilan ekran. Uzmanda `finans.abonelik.ozet`
  // var, `finans.tahsilat.goruntule` YOK — parasiz gorunumu gorur.
  {
    anahtar: "abonelik",
    ikon: "abonelik",
    etiket: "Abonelik",
    izin: ["finans.abonelik.ozet", "finans.tahsilat.goruntule"],
  },
  // Izne BAGLI DEGIL: "onaylarim" ve "basvurular" sekmeleri herkese
  // acik. Veri sahibi hakkini kullanmak bir izne baglanamaz.
  {
    anahtar: "risk",
    ikon: "risk",
    etiket: "Yenileme riski",
    izin: "analiz.risk.goruntule",
  },
  /*
    ON KATEGORI IZNININ BIRI YETERLI — UI/UX Dalga 2 (D5, 06.10.2026).
    Eskiden izne HIC baglanmamisti ("on ayri izin, menuye hepsini yazmak listeyi
    okunmaz yapardi") ve sonucu: hicbir kategoriyi goremeyen kisiye menude yine
    gorunuyor, tikladiginda "yetkiniz yok" ekrani aciliyordu — menude gorunen,
    ise yaramayan bir girdi. Liste artik tek yerde ve tipli (`PermissionCode`).
    Kategori bazli asil suzme ekranin icinde (`/denetim/log/gorunum`) ve
    sunucuda; burasi yalnizca "bu kisinin acacagi hicbir kategori yok" durumunu
    menuden cikariyor. Ekran hicbirini tasimayan kisiye (dogrudan adresle gelirse)
    yine ACIKCA "yetkiniz yok, kayit olmadigi anlamina gelmez" diyor.
  */
  {
    anahtar: "loglar",
    ikon: "log",
    etiket: "Denetim kaydı",
    izin: [
      "denetim.log.kimlik",
      "denetim.log.veri",
      "denetim.log.veri_acik",
      "denetim.log.okuma",
      "denetim.log.yetki",
      "denetim.log.isakisi",
      "denetim.log.iletisim",
      "denetim.log.finans",
      "denetim.log.aktarim",
      "denetim.log.sistem",
    ],
  },
  // Butun uclari `sistem.rol.ata` istiyor; menuyu de ona bagladim.
  // Ayrica SUDO gerekiyor — ekran ustte bunu yaziyor.
  {
    anahtar: "roller",
    ikon: "rol",
    etiket: "Rol ve izinler",
    izin: "sistem.rol.ata",
  },
  /*
    KIMLIK YETERLI (D5, 06.10.2026 — olculdu): ekranin koç icin gosterdigi
    "Onaylarim" (kendi rizalari) ve "Basvurular" (kendi KVKK basvurusu; m.11
    yolu) `@KimlikGerekli`. Yani izinsiz gorunmesi UNUTULMUS degil, dogru; bu
    yuzden `menu-alanlari.ts` icindeki acik beyaz listede (`KIMLIK_YETERLI_EKRANLAR`)
    ve Yardim/Hesabim ile ayni ALT grupta. Yonetim sekmeleri (metinler, kagit
    onayi) ekranin icinde kendi iznine bagli.
  */
  { anahtar: "kvkk", ikon: "kvkk", etiket: "KVKK", izin: undefined },
  // F-AUTH-07. Izin `sudo.ts` listesinde: ekran acilir acilmaz sifre
  // sorulur, cunku aday listesi bile kimin hangi rolde oldugunu
  // gosteriyor.
  {
    anahtar: "gorunum",
    ikon: "gorunum",
    etiket: "Kullanıcı görünümü",
    izin: "sistem.gorunum.gec",
  },
  // F-GAM — oyunlastirma yonetimi. Kurallar `oyun.kural.goruntule` (Super Admin; akademik koordinator okur); magaza
  // ve siparis (dalga 2, 7a) OPS_ADMIN'de de var ama o kural iznini tasimaz (Codex 7A-03) — menu dordunden biriyle
  // acilir, bolumler ekranda izne gore. Koc yonetim ekranini GORMEZ (Emre K5): ogrenci 360°'ta kart.
  /*
    ÖDÜL MERKEZİ — UNİKOÇ'ta dört girdi (Davet Ettiklerim, Bonus Çarkı, Mağaza, Sipariş Geçmişim),
    bizde TEK yönetim ekranı ("Ödüller", sekmeli). Sürüm 9a B2: dört menü girdisi AYNI ekranın
    ilgili sekmesine açılıyor; izin dörtte de AYNI liste (ODUL_MENU_IZINLERI), yani kimse yeni bir
    şey görmüyor, yalnız aynı ekrana dört kapıdan girilebiliyor. Sekmenin kendi izni ekranın
    içinde (OyunYonetimi) ayrıca uygulanıyor; asıl kontrol her uçta sunucuda.
    `oyunlastirma` ekran anahtarı değişmedi (adres, yardım yolu, testler): Genel sekmesi = Davet
    Ettiklerim girdisi (kurallar, davet ödülü ve şüpheli kayıtlar orada).
  */
  {
    anahtar: "oyunlastirma",
    ikon: "yeni",
    etiket: "Davet Ettiklerim",
    izin: ODUL_DAVET_PUAN_IZINLERI,
  },
  { anahtar: "odul-cark", ikon: "yeni", etiket: "Bonus Çarkı", izin: ODUL_MENU_IZINLERI },
  { anahtar: "odul-magaza", ikon: "yeni", etiket: "Mağaza", izin: ODUL_MENU_IZINLERI },
  {
    anahtar: "odul-siparis",
    ikon: "yeni",
    etiket: "Sipariş Geçmişim",
    izin: ODUL_SIPARIS_IZINLERI,
  },
  /*
    F-LIV — CANLI CALISMA IZLEME. Izin `goruntule` (koc ASSIGNED, akademik lider TEAM, operasyon/super
    yonetici ALL); `yonet` de listede cunku modul anahtari bu sayfada ve modulu kapatan kisi sayfayi
    kaybederse bir daha acamaz. Modul KAPALIYKEN yalniz `yonet` tasiyana gorunur: bu ikinci kural menu
    suzgecinde (`ekranGorunur`, modul durumu orada okunuyor); asil kontrol her uçta sunucuda.
  */
  {
    anahtar: "canli-calisma",
    ikon: "bekliyor",
    etiket: "Canlı çalışma",
    izin: ["canli.izleme.goruntule", "canli.izleme.yonet"],
  },
  /*
    F-LIV-07 — bilgilendirme sayfasi IZINSIZ: kimlik yeterli (KIMLIK_YETERLI_EKRANLAR). Yetki degil,
    "kim neyi goruyor" aciklamasi; listeyi goremeyen personel de ogrencilerinin neyi paylastigini bilmeli.
  */
  {
    anahtar: "canli-bilgilendirme",
    ikon: "bilgi",
    etiket: "Canlı izleme bilgilendirmesi",
    izin: undefined,
  },
  // F-TEC-10. Menu `duzenle` iznine bagli; ARSIVLEME ayri izin ve
  // ekran icinde ayrica kontrol ediliyor (matris §5.15/§5.16).
  {
    anahtar: "sablonlar",
    ikon: "sablon",
    etiket: "Bildirim şablonları",
    izin: "sistem.bildirim.duzenle",
  },
  // F-TEC-01/02. Izin sudo listesinde: anahtar yazmadan once sifre
  // yeniden soruluyor.
  {
    anahtar: "entegrasyonlar",
    ikon: "entegrasyon",
    etiket: "Entegrasyonlar",
    izin: "sistem.entegrasyon.duzenle",
  },
  // IKI IZIN, TEK EKRAN. Menuyu yalnizca `rapor.veli.onayla`ya
  // baglasaydim, genel onay motorunu (F-APR) kullanan ama veli
  // raporu onaylamayan bir rol ekrana HIC ulasamazdi — ekranin
  // icindeki sekme de izne gore ayrica suzuluyor.
  {
    anahtar: "onay",
    ikon: "onay",
    etiket: "Onay bekleyenler",
    izin: ["rapor.veli.onayla", "program.hafta.onayla"],
  },
  {
    anahtar: "sistem",
    ikon: "sistem",
    etiket: "Sistem sağlığı",
    izin: "sistem.ayar.duzenle",
  },
  // GORME izni, DEGISTIRME izni degil (F-SEC-09). `sistem.guvenlik.ayar`a
  // baglasaydim, konsolu okuyabilen ama degistiremeyen bir rol (denetci
  // gibi) menuyu HIC goremezdi — ve o rolun var olma sebebi tam olarak
  // bakabilmek. Ayarlarin degistirilebilmesi ayrica sudo istiyor;
  // ekran icindeki "Degistir" dugmesi sunucu SUDO_GEREKLI dondugunde
  // sifre soruyor.
  {
    anahtar: "guvenlik",
    ikon: "guvenlik",
    etiket: "Güvenlik konsolu",
    izin: "sistem.guvenlik.goruntule",
  },
  // "Sistem sagligi"ndan AYRI menu: yedek konsolunu TECH_ADMIN de
  // aciyor ve onda `sistem.ayar.duzenle` var — ama ikisini tek menuye
  // gomseydim, birini tasiyip digerini tasimayan bir rol tanimlandigi
  // gun ekranin yarisi sessizce bos acilirdi.
  {
    anahtar: "yedek",
    ikon: "yedek",
    etiket: "Yedekleme",
    izin: "sistem.yedek.yonet",
  },
  // AYRI menu ve AYRI izin: yedeklerin durumuna bakabilmek, uretim
  // verisinin uzerine yazabilmek demek degil. Ekran ayrica SUDO
  // istiyor — sunucu sordugunda sifre alani aciliyor.
  {
    anahtar: "geri-yukleme",
    ikon: "geriYukleme",
    etiket: "Geri yükleme",
    izin: "sistem.yedek.geriyukle",
  },
  // Belge FIRMA SAHIBINE yazilmis (F-YED-33) ama okuma izni
  // `sistem.yedek.yonet`: hedeflerin konumunu ve anahtar parmak
  // izlerini tasiyor. SUPER_ADMIN ve TECH_ADMIN ikisi de tasiyor,
  // yani sartnamenin istedigi iki kisi de goruyor (F-YED-35).
  {
    anahtar: "kurtarma",
    ikon: "kurtarma",
    etiket: "Kurtarma yordamı",
    izin: "sistem.yedek.yonet",
  },
  // IZNE BAGLI DEGIL (F-HLP-09): menude SABIT bir "Yardim" girisi
  // olmali. Bir izne baglasaydik, o izni tasimayan kullanici yardima
  // hic ulasamaz ve "kimseye sormadan kullanabilme" hedefi daha basta
  // duserdi. NE GORECEGI izinlerine bagli, gorup gormeyecegi degil.
  { anahtar: "yardim", ikon: "yardim", etiket: "Yardım", izin: undefined },
  // IZNE BAGLI DEGIL — ve baglanamaz. Kendi acik oturumlarini gormek,
  // 2FA kurmak ve yetki penceresini kapatmak bir yetki meselesi degil:
  // en yetkisiz kullanicinin bile bunlara ulasmasi gerekir, hatta EN
  // COK onun gerekir cunku yardim isteyecegi kimse yok.
  { anahtar: "hesap", ikon: "hesap", etiket: "Hesabım", izin: undefined },
  // Kuyruk ve zamanlanmis is yonetimi (F-TEC-03/04) + bakim modu
  // (F-TEC-08). Bakim AYRI bir izinde; ekran onu sunucu reddederse
  // gosteriyor — kuyruga bakabilmek, herkesi disari atabilmek demek
  // degil.
  {
    anahtar: "teknik",
    ikon: "teknik",
    etiket: "Teknik konsol",
    izin: "sistem.kuyruk.yonet",
  },
  // Denetim kaydindan AYRI menu: toplu ozet kimseyi isaret etmiyor ve
  // dusuk riskli bir izin (`denetim.etkinlik.toplu`), oysa denetim
  // kaydi on ayri kategori izniyle korunuyor. Ikisini tek ekrana
  // gomseydim, ozetin izni olan ama log izni olmayan kullanici
  // ekranin yarisini bos gorurdu.
  {
    anahtar: "etkinlik",
    ikon: "etkinlik",
    etiket: "Etkinlik özeti",
    izin: "denetim.etkinlik.toplu",
  },
  // BASKASININ yazismasini gerekceyle okuma (F-MSG-06). "Mesajlar"dan
  // AYRI menu ve AYRI izin: birincisi kendi kutun, bu ekran bambaska
  // bir yetki. Tek menuye gomseydim, yalnizca kendi kutusu olan
  // kullanici ekranin yarisini sessizce bos gorurdu.
  //
  // Izin ozel role EKLENEMEZ (`isRestricted`) ve sudo istiyor.
  {
    anahtar: "mesaj-denetim",
    ikon: "kvkk",
    etiket: "Yazışma denetimi",
    izin: "mesaj.icerik.oku",
  },
];

/** Ödül Merkezi girdisi → yönetim ekranının açılacağı sekme (sürüm 9a B2). */
const ODUL_ILK_BOLUM = {
  oyunlastirma: "genel",
  "odul-cark": "cark",
  "odul-magaza": "magaza",
  "odul-siparis": "siparisler",
} as const;

/** Adresin gösterebileceği ekranlar — `MENU`den türüyor, ikinci bir liste yok (adres.ts). */
const EKRAN_ANAHTARLARI: ReadonlySet<string> = new Set(MENU.map((m) => m.anahtar));

/**
 * ================================================================
 * EKRANI YAZILMIS MENU ANAHTARLARI
 * ================================================================
 * Bu liste eksik kalirsa ekran cizilir AMA altinda "henuz hazir
 * degil" yer tutucusu da gorunur. 31.07.2026'da "Adaylar" eklenirken
 * tam bu oldu ve ancak canli denemede fark edildi — birim testi
 * ekrani tek basina cizdigi icin yakalayamamisti.
 *
 * Fazla kalirsa daha kotusu olur: ekrani yazilmamis bir menu ogesi
 * BOMBOS acilir ve kullanici sistemin bozuldugunu sanar.
 *
 * Iki yonlu tutarlilik `Uygulama.test.tsx` icinde test ediliyor:
 * listedeki her anahtar MENU'de olmali, MENU'deki her anahtar ya
 * burada olmali ya da bilerek "yazilmadi" sayilmali.
 *
 * (`ogrenciler` 02.08.2026'da yazildi ve listeye eklendi.)
 */
export const YAZILAN_EKRANLAR: readonly string[] = [
  "mentorum",
  "mentorum-risk",
  "mentorum-kayitlar",
  "bugun",
  "personel-360",
  "mesajlar",
  "mesaj-denetim",
  "ogrenci-360",
  "program",
  "raporlar",
  "denemeler",
  "onay",
  "adaylar",
  "gorusmeler",
  "finans",
  "abonelik",
  "risk",
  "loglar",
  "roller",
  "gorunum",
  "sablonlar",
  "oyunlastirma",
  "odul-cark",
  "odul-magaza",
  "odul-siparis",
  "canli-calisma",
  "canli-bilgilendirme",
  "entegrasyonlar",
  "kvkk",
  "takvim",
  "operasyon",
  "notlarim",
  "talepler",
  "sistem",
  "ogrenciler",
  "personel",
  "mufredat",
  "kaynaklar",
  "deneme-tanim",
  "kocluk",
  "konular",
  "ogrenci-kaynak",
  "konu-plani",
  "haftalik-analiz",
  "ogrenci-planlari",
  "bildirimler",
  "dosya",
  "hata-defteri",
  "yedek",
  "guvenlik",
  "geri-yukleme",
  "kurtarma",
  "yardim",
  "teknik",
  "etkinlik",
  "hesap",
];

interface SecilenOgrenci {
  id: string;
  ad: string;
}

export function Uygulama() {
  /*
    ================================================================
    ÇEVRİMDIŞI — PANEL BAĞLANTI KAYBINI SÖYLÜYOR
    ================================================================
    Sorgu istemcisi `networkMode: "always"` ile hata veriyor
    (main.tsx'teki not), yani ekranlar tek tek "alınamadı" diyordu.
    On ayrı ekranda on ayrı hata mesajı görmek, bağlantının kesik
    olduğunu anlamayı zorlaştırıyor.

    `navigator.onLine` YALNIZCA NEGATİF yönde güveniliyor: `false`
    ise bağlantı kesin yok; `true` bağlantının çalıştığını
    KANITLAMAZ (ağ var ama internet yok olabilir). O yüzden burada
    yalnızca "kesin yok" durumu bant açıyor.

    14.09.2026: tam ekran erken dönüş kaldırıldı; açık formun sökülmesi
    yazılanları kaybettiriyordu. BaglantiBandi en dışta çizilir, bakım
    isteği beklenmeden görünür ve mevcut ekran/form yerinde kalır.
  */

  return (
    <>
      <BaglantiBandi />
      <PanelUygulamasi />
    </>
  );
}

function PanelUygulamasi() {
  const qc = useQueryClient();
  // Ekran adresten başlıyor: yenileme ve paylaşılan bağlantı aynı ekranı açsın (adres.ts).
  const [aktif, setAktifHam] = useState(
    () => yoldanEkran(window.location.pathname, EKRAN_ANAHTARLARI) ?? ANA_EKRAN,
  );
  /*
    Secili personel MENULER ARASINDA KORUNUYOR — secili ogrenciyle ayni
    gerekce: kullanici 360 ekranindan cikip geri donunce secimini
    yeniden yapmak zorunda kalmasin.
  */
  const [personel, setPersonel] = useState<{ id: string; ad: string } | null>(null);

  /**
   * ================================================================
   * DAVET VE ŞİFRE SIFIRLAMA — OTURUMDAN ÖNCE
   * ================================================================
   * Sunucu bu iki bağlantıyı üretiyor (`jeton.service.ts`) ve ikisi de
   * panele düşüyor (`APP_URL`). Sayfa oturum sorgusunu BEKLEMEDEN
   * açılıyor, çünkü:
   *
   *   - Davete tıklayan kişinin zaten oturumu yok; `/auth/ben`
   *     cevabını beklemek boşuna gecikme.
   *   - Şifresini sıfırlayan kişinin oturumu OLABİLİR — ve o oturum
   *     işlem bitince zaten kapanıyor. Girişli sayılıp panele
   *     alınsaydı, bağlantıya tıklayan kişi şifresini hiç
   *     değiştiremezdi.
   *
   * `useState` başlangıcında bir kez okunuyor: jeton sayfasındayken
   * adres değişmiyor (ekran adresi yalnız panelin içinde güncelleniyor).
   */
  const [jetonSayfasi] = useState(() =>
    jetonSayfasiCozumle(window.location.pathname, window.location.search),
  );

  /*
    ================================================================
    BİLİNMEYEN ADRES — 404
    ================================================================
    Panelin tanıdığı adresler: jeton sayfaları ve ekran adresleri
    (`/finans`, `/program`… — adres.ts). Bugüne kadar `/olmayan-sayfa`
    açan kullanıcı SESSİZCE ana ekrana düşüyordu: yanlış bağlantı
    çalışmış gibi görünüyordu ve kullanıcı aradığını bulamayınca
    sistemin bozuk olduğunu düşünüyordu.

    Bir kez, açılışta okunuyor: panelin içinde adres yalnızca tanınan
    ekran adreslerine güncelleniyor, yani sonradan bilinmeyen bir
    adrese geçilemez.
  */
  const [bilinmeyenAdres] = useState(() => {
    const yol = window.location.pathname.replace(/\/+$/, "") || "/";
    return (
      yol !== "/" &&
      jetonSayfasiCozumle(window.location.pathname, "") === null &&
      yoldanEkran(window.location.pathname, EKRAN_ANAHTARLARI) === null
    );
  });

  /**
   * Yardim acilmadan ONCE hangi ekrandaydik (F-HLP-12).
   *
   * Yardim ekrani `aktif` degerini kendisi ezdigi icin, "nereden
   * geldim" bilgisi ayri tutulmak zorunda. Yardimdan yardima gecis
   * KAYDEDILMIYOR: yoksa yardimi ikinci kez acan kullanici, baglam
   * olarak yine "yardim"i gorurdu.
   */
  const [oncekiEkran, setOncekiEkran] = useState<string | null>(null);

  const ekranaGec = (yeni: string): void => {
    setAktifHam((eski) => {
      if (yeni === "yardim" && eski !== "yardim") setOncekiEkran(eski);
      return yeni;
    });
  };
  /*
    Ekran değişimi adrese TEK YERDEN yazılıyor: kırk küsur `setAktif`
    çağrısının her birine adres eklemek, birini unutmak demekti
    (CLAUDE.md kural 10). Geri/ileri tuşu `popstate` ile aynı ekrana
    döner ama geçmişe YENİ kayıt yazmaz — yazsaydı ileri tuşu bozulurdu.
  */
  const setAktif = (yeni: string): void => {
    ekranaGec(yeni);
    const yol = ekranYolu(yeni);
    if (window.location.pathname !== yol) window.history.pushState(null, "", yol);
  };
  useEffect(() => {
    const geriIleri = (): void => {
      const ekran = yoldanEkran(window.location.pathname, EKRAN_ANAHTARLARI);
      if (ekran !== null) ekranaGec(ekran);
    };
    window.addEventListener("popstate", geriIleri);
    return () => window.removeEventListener("popstate", geriIleri);
  }, []);
  const [ogrenci, setOgrenciHam] = useState<SecilenOgrenci | null>(null);
  // F-REP-07a — eksik haftalık rapor satırından gelinen hafta; Raporlar
  // "Yeni rapor" formunu bu dönemle açar. Öğrenci değişince düşer.
  const [raporDonemi, setRaporDonemi] = useState<{
    ogrenciId: string;
    bas: string;
    bit: string;
  } | null>(null);
  // Dönem YALNIZ seçildiği öğrenciye uygulanır: başka yoldan (iş listesi,
  // arama) başka öğrenciye geçilince eski hafta formu doldurmasın.
  const raporDonemiBu = raporDonemi && ogrenci?.id === raporDonemi.ogrenciId ? raporDonemi : null;

  const { data: ben, isPending } = useQuery<Ben>({
    queryKey: ["ben"],
    queryFn: benGetir,
    // Oturum durumu her odaklanmada tazeleniyor: baska sekmede cikis
    // yapildiysa bu sekme de fark etsin.
    refetchOnWindowFocus: true,
    retry: false,
  });

  /**
   * Öğrenci bağlamını kurar VE "son kullanılanlar"a yazar — F-STV-16.
   *
   * ================================================================
   * NEDEN SARMALAYICI, NEDEN 11 ÇAĞRI YERİNE TEK TEK EKLEME DEĞİL
   * ================================================================
   * Bu dosyada bağlam **on bir ayrı yerden** kuruluyor: seçici,
   * bildirim yönlendirmesi, iş listesi, öğrenci dosyası… Kaydı her
   * birine tek tek eklemek, on ikincisini eklemeyi unutmak demekti —
   * ve unutulduğunda hiçbir şey bağırmaz, özellik yalnızca bazı
   * yollarda sessizce çalışmaz.
   *
   * CLAUDE.md kural 10: *"Yeni bir koruma eklerken sor: bunu eklemeyi
   * unutabilir miyim? Cevap evetse yeri yanlış."* Kayıt bağlam
   * kurmanın **kendisine** bağlandı: `setOgrenciHam`ın tek çağıranı bu
   * sarmalayıcı, yani on bir yolun hepsi kaydı ücretsiz alıyor.
   *
   * Öğrenci seçicideki liste `localStorage`ta ve kullanıcıya bağlı;
   * sunucuya yazılsaydı "kimin kime baktığı" verisi doğar ve denetim
   * kaydının dışında ikinci bir izleme kaynağı oluşurdu (F-STV-16).
   */
  const onayKilitli = Boolean(
    ben?.girisYapildi &&
    (onayBilgisi.kilitli(ben.userId) || (ben.onayKilidi?.kilitli && !ben.onayKilidiDevreDisi)),
  );
  useEffect(() => {
    const yenile = () => {
      qc.setQueryData<Ben>(["ben"], (eski) =>
        eski ? onayBilgisi.benYanitiniIsle(eski, false) : eski,
      );
      void qc.invalidateQueries({ queryKey: ["ben"] });
    };
    window.addEventListener("onay-kilidi", yenile);
    return () => window.removeEventListener("onay-kilidi", yenile);
  }, [qc]);

  const setOgrenci = useCallback(
    (secim: SecilenOgrenci | null) => {
      setOgrenciHam(secim);
      if (secim) sonOgrenciyiYaz(ben?.userId ?? null, { id: secim.id, ad: secim.ad });
    },
    [ben?.userId],
  );

  /*
    ================================================================
    OTURUM NASIL BİTTİ — İKİSİ AYRI EKRAN
    ================================================================
    "Çıkış yaptım" ile "oturumum düştü" kullanıcı için apayrı iki
    olay: birincisi kendi kararı, ikincisi ona olan bir şey. İkisini
    de giriş ekranına düşürmek, ikinci durumdaki kullanıcıya hiçbir
    şey açıklamıyordu — "beni neden attı" sorusu cevapsız kalıyordu.
  */
  const [oturumSonu, setOturumSonu] = useState<"cikis" | "dustu" | null>(null);
  const [sifreUnuttum, setSifreUnuttum] = useState(false);

  /*
    ================================================================
    HESAP KİLİDİ AYRI BİR EKRAN
    ================================================================
    Sunucu `kod: "KILITLI"` dönüyor ve giriş formu bunu küçük kırmızı
    bir satır olarak gösteriyordu — yani kullanıcıyı aynı şifreyi bir
    kez daha denemeye davet eden bir yerde. Her deneme kilidi
    uzatıyor.

    Durum GİRİŞ EKRANININ DEĞİL, buranın: giriş bileşeni yeniden
    çizildiğinde kilit bilgisi kaybolmamalı.
  */
  const [kilit, setKilit] = useState<{ dakika: number | null } | null>(null);

  /*
    G-AUT-02a — yedek kodla girildiyse kalan sayı.
    On kod bitince hesabı yalnızca yönetici açabiliyor; kullanıcı
    bunu bugüne kadar ancak KİLİTLENDİĞİNDE öğreniyordu.
  */
  const [yedekKodUyarisi, setYedekKodUyarisi] = useState<number | null>(null);

  /*
    G-AUT-01d — 2FA kurmamış PERSONELE hatırlatma bandı.

    Sorgu `retry: false` ve hatası SESSİZCE yutuluyor: 2FA durumu
    okunamadı diye paneli uyarıyla doldurmak, olmayan bir sorunu
    varmış gibi göstermek olurdu.
  */
  /*
    ================================================================
    "ŞİMDİ DEĞİL" ON DÖRT GÜN SÜRÜYOR — SEKME ÖMRÜ KADAR DEĞİL
    ================================================================
    Bu değer `useState(false)` idi: kapatma yalnızca o sekme
    oturumunda geçerliydi ve sayfa yenilenince bant geri geliyordu.
    Yani kullanıcı aynı kararı günde defalarca veriyordu; bir bant
    o noktadan sonra artık okunmuyor ve yanındaki gerçek uyarıları
    da görünmez yapıyor.

    Kalıcılık tarayıcıda ve kullanıcıya bağlı; ne saklandığı ve
    neden bayrak değil tarih olduğu `uyari-erteleme.ts` başında.
    Sunucuya yazılmadı: bu bir tercih değil, tek bir ekranın
    gürültü ayarı — ve sunucuya yazmak "kim 2FA kurmayı erteledi"
    listesi üretirdi.

    İlk değer `false`: kimlik `ben` sorgusundan SONRA geliyor, o
    yüzden gerçek okuma aşağıdaki etkide yapılıyor. Bant zaten
    `personelMi` olmadan çizilmiyor, yani kimlik gelmeden görünen
    bir an yok.
  */
  const [ikiAsamaKapatildi, setIkiAsamaKapatildi] = useState(false);
  useEffect(() => {
    setIkiAsamaKapatildi(ertelemeSuruyorMu(IKI_ASAMA_UYARISI, ben?.userId ?? null));
  }, [ben?.userId]);

  const cikis = useMutation({
    mutationFn: cikisYap,
    // Basarisiz olsa bile onbellek temizleniyor: cerez zaten sunucuda
    // gecersiz olabilir ve kullaniciyi giris yapmis gibi gostermek
    // daha kotu.
    onSettled: () => {
      setOturumSonu("cikis");
      void qc.invalidateQueries();
    },
  });

  /*
    OTURUM DÜŞTÜ: kullanıcı GİRİŞ YAPMIŞKEN cevap `girisYapildi: false`
    olduysa. İlk açılışta değil — o zaman zaten giriş ekranı gelmeli.

    `ben` bir kez dolu geldiyse ve sonra boşaldıysa, aradaki fark
    "oturum bitti" demek. Bu ayrımı yapmasaydık, panele ilk kez giren
    herkes "oturum süresi doldu" ekranı görürdü.
  */
  /*
    ================================================================
    BAKIM MODU — KULLANICIYA GÖSTERİLEN TARAF
    ================================================================
    Bakımı AÇMA ekranı vardı (`TeknikKonsol`), kullanıcının gördüğü
    ekran yoktu: bakım açıkken panel normal açılıyor ve her istek
    hata veriyordu. Kullanıcı "sistem bozuldu" sanıyordu.

    Uç `@HerkeseAcik()` ve hafif; oturum sorgusuyla birlikte
    koşuyor. Hata verirse SESSİZCE geçiliyor: bakım durumu
    okunamadı diye paneli kapatmak, olmayan bir bakımı varmış gibi
    göstermek olurdu.
  */
  const bakim = useQuery({
    queryKey: ["bakim-durum-panel"],
    queryFn: bakimDurumu,
    retry: false,
    // Bakım açılırsa kullanıcı yenilemeden görsün.
    refetchInterval: 60_000,
  });

  /*
    2FA durumu — G-AUT-01d bandi bundan besleniyor.

    `enabled`: yalnizca giris yapmis PERSONEL icin sorgulaniyor.
    Ogrenci ve veli kapsam disinda (sartname G-AUT-01: onlarda yontem
    TOTP degil) ve giris yapilmadan sorulmasi 401 uretirdi.
  */
  /*
    ================================================================
    ROL ADI DEĞİL, SUNUCUNUN CEVABI — 05.09.2026
    ================================================================
    Önceki hâli şuydu:

        !ben?.roller.includes("PARENT") && !ben?.roller.includes("STUDENT")

    İki kusuru vardı ve ikincisi sessizdi:

    1. Rol ADINA dallanıyordu (CLAUDE.md 1. madde). Roller değişken,
       izinler sabit.

    2. **Yanlış kümeye bakıyordu.** `roller` içinde özel tanımlı bir
       rol de bulunabilir; "öğrenci değil, veli değil" cümlesi onu
       personel sayar — ki bugün doğru olabilir, ama *sebebi yanlış*:
       o kişinin personel olduğunu değil, **listede tanımadığımız bir
       şey olduğunu** ölçüyordu.

    Sunucu artık bu soruyu doğrudan cevaplıyor ve cevabını
    `Student` / `StudentParent` **kayıtlarından** üretiyor.

    ⚠️ İki bayrağın da `false` olması "personel" demek — üçüncü bir
    alan İSTENMEDİ, çünkü üç alan birbiriyle tutarsız hâle gelebilirdi.
  */
  const personelMi = Boolean(ben?.girisYapildi) && Boolean(ben?.personelMi);

  const ikiAsama = useQuery({
    queryKey: ["2fa-durum-bant"],
    queryFn: ikiAsamaDurum,
    enabled: personelMi && !onayKilitli,
    retry: false,
    staleTime: 5 * 60_000,
  });

  /*
    F-LIV-05 — CANLI IZLEME MODUL DURUMU, MENU ICIN. Yalniz izleme iznini (goruntule ya da yonet)
    tasiyan personel icin sorgulaniyor: digerlerinin menusunde ogenin hic gorunmeyecegi belli, bos
    yere istek atmak ve her acilista sunucu kaydi uretmek gereksiz. Hata SESSIZCE yutuluyor: durum
    okunamadiysa oge gizli kalir (kapali sayilir) — acik oldugunu varsaymak, kapali bir modulun
    menusunu gostermek olurdu. Sayfa AYNI sorgu anahtarini kullaniyor, anahtar degisince menu de tazelenir.
  */
  const canliIlgili =
    personelMi &&
    !onayKilitli &&
    ben?.izinler !== undefined &&
    (izinVarMi(ben.izinler, "canli.izleme.goruntule") ||
      izinVarMi(ben.izinler, "canli.izleme.yonet"));
  // F-MNT-01 — bayrak öğrenci veya kayıt okumayan kimlik ucundan öğrenilir; hata halinde menü gizlidir.
  const mentorumIlgili =
    personelMi &&
    !onayKilitli &&
    ben?.izinler !== undefined &&
    biriVarMi(ben.izinler, [
      "kvkk.riza.kagit_kaydet",
      "mentorum.erisim.goruntule",
      "mentorum.erisim.yonet",
      "mentorum.icerik.yonet",
      "mentorum.risk.goruntule",
      "mentorum.kayit.goruntule",
    ]);
  const mentorumModul = useQuery({
    queryKey: ["mentorum", "modul"],
    queryFn: async ({ signal }) =>
      mentorumModulDurumuSemasi.parse(await api("/mentorum/modul-durumu", { signal })),
    enabled: mentorumIlgili,
    retry: false,
    staleTime: 0,
  });
  const [mentorumOgrenciId, setMentorumOgrenciId] = useState<string>();
  // ME02-01 — risk satırından gelen öğrenci tek kullanımlıktır: Kayıtlar'dan çıkınca unutulur. Kalsaydı menüden
  // sonraki girişte psikolojik kayıt kimse öğrenci seçmeden okunur ve erişim günlüğüne yazılırdı (F-MNT-13).
  useEffect(() => {
    if (aktif !== "mentorum-kayitlar") setMentorumOgrenciId(undefined);
  }, [aktif]);

  const canliModul = useQuery({
    queryKey: CANLI_MODUL_ANAHTARI,
    queryFn: () => canliModulDurumu(),
    enabled: canliIlgili,
    retry: false,
    staleTime: 60_000,
  });

  /*
    YAN MENUDEKI PROFIL BLOGU (UNİKOÇ, sürüm 9a): kisinin kendi adi ve rol adi.
    Uc `@KimlikGerekli` — izin istemiyor, kimse baskasinin profilini bu kapidan
    alamiyor. Anahtar Hesabim ekraniyla AYNI: ad degisince menu de tazelenir.
    Hata sessiz: blok yer tutucuda kalir, panel calismaya devam eder.
  */
  const profilim = useQuery({
    queryKey: ["profilim"],
    queryFn: kendiProfilim,
    enabled: personelMi && !onayKilitli,
    retry: false,
    staleTime: 5 * 60_000,
  });

  const ikiAsamaHatirlat =
    personelMi &&
    !ikiAsamaKapatildi &&
    // Hesabım'da kurulum karti zaten ayni seyi soyluyor; bant ustte ikinci
    // kez yaziyordu (UI/UX Dalga 1, M-01/M-16).
    aktif !== "hesap" &&
    ikiAsama.data !== undefined &&
    !ikiAsama.data.kuruldu &&
    ikiAsama.data.etkinPolitika !== "DISABLED";

  const [girmisti, setGirmisti] = useState(false);
  useEffect(() => {
    if (ben?.girisYapildi) setGirmisti(true);
    else if (girmisti && oturumSonu === null) setOturumSonu("dustu");
  }, [ben?.girisYapildi, girmisti, oturumSonu]);

  // Oturum sorgusundan ONCE: gerekcesi `jetonSayfasi` tanimindaki notta.
  if (jetonSayfasi) {
    /*
      ANKET AYRI BILESEN: oteki iki akis sifre formu, anket degil.
      Tek bilesene sikistirmak, iki farkli isi tek bir "jeton sayfasi"
      soyutlamasinin altina gomerdi.
    */
    return jetonSayfasi.akis === "anket" ? (
      <AnketSayfasi jeton={jetonSayfasi.jeton} />
    ) : (
      <JetonSayfasi sayfa={jetonSayfasi} />
    );
  }

  /*
    BAKIM EKRANI GİRİŞ KONTROLÜNDEN ÖNCE.
    Sonra gelseydi, bakım sırasında giriş yapmaya çalışan kullanıcı
    önce giriş ekranını görür, şifresini yazar ve ancak o zaman
    "sistem kapalı" öğrenirdi.

    TEKNİK YÖNETİCİ HARİÇ TUTULMUYOR ve bu bilinçli: bakımı kapatmak
    için panele girmesi gerekmiyor, kendi konsolu ayrı bir yoldan
    çalışıyor. Hariç tutsaydık, "bakım açık mı" sorusunun cevabı
    kime sorduğuna göre değişirdi.
  */

  if (bilinmeyenAdres) {
    return <Hata404 onBugun={() => window.location.assign("/")} />;
  }

  if (bakim.data?.acik) {
    return <BakimModu mesaj={bakim.data.mesaj} bitis={bakim.data.bitisTahmini} />;
  }

  if (isPending) {
    return <Iskelet satir={4} />;
  }

  if (!ben?.girisYapildi) {
    if (sifreUnuttum) {
      return <SifremiUnuttum onGiris={() => setSifreUnuttum(false)} />;
    }
    if (oturumSonu === "cikis") {
      return <CikisYapildi onGiris={() => setOturumSonu(null)} />;
    }
    if (oturumSonu === "dustu") {
      return (
        <OturumSuresiDoldu
          onGiris={() => {
            setOturumSonu(null);
            setGirmisti(false);
          }}
        />
      );
    }
    if (kilit !== null) {
      return (
        <HesapKilitli
          kalanDakika={kilit.dakika}
          onGiris={() => setKilit(null)}
          onSifremiUnuttum={() => {
            setKilit(null);
            setSifreUnuttum(true);
          }}
        />
      );
    }
    return (
      <Giris
        onGirdi={(kalanYedekKod) => {
          setYedekKodUyarisi(kalanYedekKod);
          void qc.invalidateQueries({ queryKey: ["ben"] });
        }}
        onSifremiUnuttum={() => setSifreUnuttum(true)}
        onKilitlendi={(dakika) => setKilit({ dakika })}
      />
    );
  }

  // ================================================================
  // VELI PERSONEL MENUSUNU HIC GORMUYOR
  // ================================================================
  // Menuyu izne gore suzmek yetmezdi: velinin `kisi.ogrenci.goruntule`
  // izni LINKED kapsamiyla var, yani "Ogrenciler" menusu ona da
  // gorunurdu ve tikladiginda bos ya da yaris bir ekran acilirdi.
  //
  // Rol bazli dallanma DEGIL, EKRAN SECIMI: hangi izinlerin oldugu
  // degil, kullanicinin hangi UYGULAMAYI kullandigi belirleniyor.
  // Yetki kontrolu her istekte sunucuda ayrica yapiliyor.
  /*
    ================================================================
    VELI ARTIK BU UYGULAMADA DEGIL — 05.09.2026
    ================================================================
    Burada `ben.roller.includes("PARENT")` ile bir ekran secimi
    yapiliyordu ve yanina "rol bazli dallanma DEGIL, ekran secimi"
    diye bir gerekce yazilmisti.

    Emre karar verdi: veli `apps/ogrenci`ye tasindi (sartname zaten
    oyle diyordu, kod tersini yapiyordu — C14.31). Boylece:

      - buradaki rol adina dallanma tamamen kalkti
      - velinin tarayicisi artik BUTUN YONETIM PANELININ kodunu
        indirmiyor. Veri sizmiyordu (yetki her istekte sunucuda) ama
        veliye personel uygulamasinin tam haritasi veriliyordu:
        41 ekranin adi, akisi, alan yapisi.

    Veli buraya girerse ne olur: `/auth/ben` `veliMi: true` donuyor ve
    ogrenci uygulamasi onu karsiliyor. Panel tarafinda ayrica bir
    yonlendirme YAZILMADI — sunucunun sifre/davet baglantilarini
    kisiye gore dogru adrese gondermesi giris oturumunun isi (C55).
  */

  // ================================================================
  // OGRENCI PERSONEL KABUGUNU GORMEZ
  // ================================================================
  // Yukaridaki gerekce ("kullanicinin hangi UYGULAMAYI kullandigi")
  // ogrenci icin de gecerliydi ama YALNIZCA veli icin yazilmisti.
  // 05.08.2026'da manuel test listesi uygulanirken canli goruldu:
  // `ogrenci@dev.local` panele girdiginde personel kabugunu aciyor ve
  // PERSONELE yazilmis ilk giris turunu okuyordu — "Ogrencinin
  // haftasini burada kurarsiniz".
  //
  // Veri sizintisi DEGIL: sunucu kapsami her istekte uyguluyor ve
  // ogrencinin kapsami SELF. Ama ekran yanlis kisiye yanlis dili
  // konusuyordu ve "Denetim kaydi", "KVKK", "Finans" gibi menuleri
  // ogrenciye gosteriyordu.
  //
  // ADRES VERILMIYOR: ogrenci uygulamasinin adresi ortama gore
  // degisiyor ve panelde bunun icin bir ayar YOK. Uydurulmus bir
  // baglanti (`localhost:3010` gibi) uretimde sessizce kirik olurdu;
  // olmayan bir adresi gostermek, hic gostermemekten kotu.
  //
  // ================================================================
  // 05.09.2026 — İKİ DÜZELTME: ROL ADI KALKTI, VELİ GERİ GELDİ
  // ================================================================
  // 1) Koşul `ben.roller.includes("STUDENT")` idi. Rol ADINA
  //    dallanıyordu (CLAUDE.md 1) **ve** yanlış kümeye bakıyordu:
  //    `roller` içinde özel tanımlı bir rol de bulunabilir ve o
  //    listede öğrenci olduğu görünmeyebilir. Sunucu artık soruyu
  //    doğrudan cevaplıyor (`ogrenciMi`, `Student` KAYDINDAN).
  //
  // 2) 🔴 VELİ TAŞININCA BU KAPI VELİYE KAPANDI VE KİMSE AÇMADI.
  //    Veli `apps/ogrenci`ye taşındığında panelin `PARENT` dalı
  //    kaldırıldı — doğru — ama yerine bir şey konmadı. Sonucu:
  //    panele giren bir veli bu karta HİÇ düşmüyor, personel
  //    kabuğunu açıyordu.
  //
  //    Veri sızıntısı değil (sunucu kapsamı her istekte uyguluyor ve
  //    menü izne göre süzülüyor), ama ekran yanlış kişiye yanlış
  //    uygulamayı gösteriyordu — bu kartın var olma sebebinin ta
  //    kendisi. Bir dalı kaldırmak, onun kapattığı deliği de
  //    kapatmıyor.
  //
  //
  // ================================================================
  // GEÇİCİ KOŞUL KALKTI — SUNUCU ARTIK `personelMi` SÖYLÜYOR
  // ================================================================
  // Ara dönemde `ogrenciMi || veliMi` yazıyordu ve bilinen bir kusuru
  // vardı: **hem personel hem veli** olan kişiyi (çocuğu aynı kurumda
  // okuyan bir koç) panelden atıyordu. Canlı ölçüldü — gerçek bir
  // koç+veli hesabı açılıp `personelMi = true`, türetilmiş koşul
  // `false` verdi.
  //
  // O koşul yine de bilerek bırakılmıştı: kapattığı gedik CANLI idi
  // (veli taşındıktan sonra panele giren veli 41 menüden 21'ini
  // görüyordu — Denetim kaydı, KVKK, Finans dahil) ve 0 kişilik
  // varsayımsal bir kilit, gerçek bir gedikten iyidir.
  //
  // Artık geçici değil: `personelMi` ham rol atamalarından çözülüyor
  // ve `ogrenciMi`/`veliMi`den **türemiyor** — üçü birbirinden
  // bağımsız.
  //
  if (onayKilitli) return <OnayKilidi ben={ben} onCikis={() => cikis.mutate()} />;

  if (!ben.personelMi) {
    /*
      TEK KART, İKİ CÜMLE. Öğrenciye "programın", veliye "çocuğunun
      ilerlemesi" demek gerekiyor — aynı cümle ikisine de doğru
      gelmiyor. Ama kartın kendisi bir: ikisi de aynı yanlış
      uygulamadalar ve ikisinin de yapması gereken aynı.

      Hem öğrenci hem veli olan kişide ÖĞRENCİ cümlesi kazanıyor:
      o kişinin kendi verisi, çocuğunun verisinden önce gelir.
    */
    const ogrenciCumlesi =
      "Öğrenci hesabınızla giriş yaptınız. Programınız, denemeleriniz ve görevleriniz öğrenci uygulamasında — bu panel koçlar ve yöneticiler için.";
    const veliCumlesi =
      "Veli hesabınızla giriş yaptınız. Çocuğunuzun ilerlemesi, raporları ve görüşmeleri öğrenci uygulamasında — bu panel koçlar ve yöneticiler için.";

    return (
      <Cerceve>
        <div className="mx-auto flex min-h-screen max-w-md items-center p-4">
          <Kart baslik="Burası personel paneli" ton="uyari">
            <p className="text-notr-700 text-sm">{ben.ogrenciMi ? ogrenciCumlesi : veliCumlesi}</p>
            <p className="text-notr-700 mt-2 text-sm">
              Öğrenci uygulamasının adresini bilmiyorsanız uzmanınıza sorun.
            </p>
            <div className="mt-4">
              <Buton onClick={() => cikis.mutate()}>Çıkış yap</Buton>
            </div>
          </Kart>
        </div>
      </Cerceve>
    );
  }

  /*
    ================================================================
    İZİN SORUSU TEK KAPIDAN — VE TİPTEN GEÇİYOR
    ================================================================
    Bu dosyada yirmi yerde `"kod" in ben.izinler` yazılıydı ve hiçbiri
    yazım hatasına karşı korunmuyordu: yanlış yazılan kod sessizce
    `false` döner, düğme hiç görünmez, kimse sebebini aramaz.

    05.09.2026'da tarandı ve **bir tane** çıktı — aşağıdaki
    `program.hafta.duzenle`. Ayrıntı `izin.ts` başlığında.
  */
  const izinVar = izinSorgusu(ben.izinler);

  // Izin LISTE olabilir: bir menunun isini iki ayri rol yapiyorsa
  // (yazan / onaylayan) ikisi de gorebilmeli. Bkz. `MenuOgesi.izin`.
  const menuIzinli = (m: MenuOgesi): boolean =>
    !m.izin || (typeof m.izin === "string" ? izinVar(m.izin) : biriVarMi(ben.izinler, m.izin));
  const ekranGorunur = (ekran: string): boolean => {
    const m = MENU.find((o) => o.anahtar === ekran);
    if (m === undefined || !menuIzinli(m)) return false;
    /*
      F-LIV-05 — modul KAPALIYKEN (ya da durumu henuz bilinmiyorken) canli calisma menusu izleyiciden
      gizli; anahtari yonetebilen kisi icin acik kalir ki modulu geri acabilsin.
    */
    if (ekran === "mentorum" || ekran.startsWith("mentorum-"))
      return mentorumModul.isSuccess && mentorumModul.data.acik;
    if (ekran === "canli-calisma") {
      return canliModul.data?.acik === true || izinVar("canli.izleme.yonet");
    }
    return true;
  };
  const ekranEtiketi = (ekran: string): string =>
    MENU.find((o) => o.anahtar === ekran)?.etiket ?? ekran;
  /*
    YAN MENU ARTIK EKRAN DEGIL ALAN LISTESI — UI/UX Dalga 2 (M1, D1).
    `gorunurMenu` (ekran listesi) yalnizca bu dosyadaki sorgular icin duruyor;
    kabuga giden liste `alanlar`. Gerekce ve kurallar `menu-alanlari.ts`.
  */
  const gorunurMenu = MENU.filter(menuIzinli);
  const alanlar = gorunurAlanlar(ekranGorunur, ekranEtiketi);
  const aktifAlan = alanlar.find((a) => a.anahtar === alanOf(aktif));
  const kabukMenusu: MenuOgesi[] = alanlar.map((a) => ({
    anahtar: a.anahtar,
    etiket: a.etiket,
    ikon: a.ikon,
    ekranlar: a.ekranlar,
    ...(a.grup !== undefined ? { grup: a.grup } : {}),
    ...(a.bolum !== undefined ? { bolum: a.bolum } : {}),
  }));
  /** Bir ekrana gecis: ogrenci baglamindan CIKARKEN secim birakiliyor. */
  const ekranaGit = (ekran: string): void => {
    setAktif(ekran);
    // "Bugün"e donen uzman butun ogrencileri gormeli, bir oncekine bagli kalmamali.
    if (!OGRENCI_EKRANLARI.includes(ekran)) setOgrenci(null);
  };
  /*
    SAYFA BASLIGI = MENUDEKI UNİKOÇ ETIKETI (sürüm 9a B2). Eskiden baslik ekranin kendi adiydi
    ("Bugün", "Haftalık analiz"); menu ise "Anasayfa", "Analiz ve Raporlama" diyordu ve kullanici
    tikladigi girdiyle sayfanin basligini eslestiremiyordu. Alanin SEKMESI olan ekranda
    (Deneme Sınavları ▸ Deneme tanımla) baslik yine girdinin adi; sekme adi sekme cubugunda
    gorunuyor. Ogrenci baglamli ekranlar (360°, dosya) alanin sekmesi degil, kendi adini tasiyor.
  */
  const baslik =
    aktifAlan && aktifAlan.sekmeler.includes(aktif)
      ? aktifAlan.etiket
      : (MENU.find((m) => m.anahtar === aktif)?.etiket ?? marka.kisaAd);

  /*
    ================================================================
    "BUGÜN" EKRANI BU KULLANICIDA HİÇBİR ŞEY ÇİZMEYECEK Mİ
    ================================================================
    `YoneticiBugun` beş kaynağı özetliyor ve yetkisi olmayanı
    çıkarıyor; `IsListesi` uzman olmayana `null` dönüyor. İkisi de
    doğru davranıyor ama ikisi birden çekilince ekran bomboş kalıyordu.

    Beş izin BURADA sayılıyor — bileşenlerin içinden değil. İki
    dosyada iki liste tutmak, biri değişince ötekinin sessizce
    eskimesi demek olurdu; bu yüzden liste `YONETICI_BUGUN_IZINLERI`
    diye TEK yerde ve menü tanımlarıyla aynı izin kodlarını
    kullanıyor.

    Uzmanlık kontrolü `IsListesi`in kendi ölçütüyle aynı: iş listesi
    ucu uzman olmayana `UZMAN_DEGIL` dönüyor ve o kişide bileşen hiç
    çizilmiyor. Burada aynı soruyu izinden soruyoruz — sunucuya
    ikinci bir istek atmamak için.
  */
  const bugunKaynakIzinleri: readonly PermissionCode[] = [
    "rapor.veli.onayla",
    "program.hafta.onayla",
    "finans.tahsilat.goruntule",
    "finans.paket.yonet",
    "yardim.destek.olustur",
    "operasyon.duyuru.goruntule",
    "crm.aday.goruntule",
  ];
  /*
    ================================================================
    ÖLÜ SATIR SİLİNDİ — KARAR EMRE'NİN (06.09.2026)
    ================================================================
    Koşulda, program modülünde var olmayan bir "düzenle" iznine bakan
    fazladan bir terim vardı. Katalogda o kaynağın yalnızca
    `goruntule` / `olustur` / `yayinla` / `onayla` işlemleri tanımlı.
    Yani terim yazıldığından beri hep `false` dönüyor, `!false === true`
    olduğu için koşula hiçbir şey katmıyordu.

    (Kodun kendisi buraya YAZILMIYOR: `izin-tarama.test.ts` kaynağı
    tarıyor ve yorumla kodu ayırmıyor — ki doğrusu bu. Ayırsaydı,
    yoruma gizlenmiş bir izin kodu taramadan kaçardı.)

    Niyeti şuydu: yedi kaynağın hiçbirine erişemeyen ama İŞ LİSTESİ
    olan bir kullanıcı boş ekranla karşılaşmasın.

    Emre'ye iki seçenek sunuldu — iş listesini de saymak, ya da satırı
    silmek — ve **silmeyi seçti**. Yani ana ekranlara erişemeyen bir
    kullanıcı, iş listesi olsa bile "görüntülenecek bir şey yok"
    mesajını görüyor. Bugün kimseyi etkilemiyor: dokuz tohum rolünün
    dokuzu da yedi kaynaktan en az ikisine sahip (canlı ölçüldü).
  */
  const bugunBos = ben.girisYapildi && !biriVarMi(ben.izinler, bugunKaynakIzinleri);

  /*
    Kullanıcının GERÇEKTEN gidebileceği ekranlar — menünün kendi
    süzgeciyle aynı ölçüt. "Bugün" listeden çıkarılıyor: zaten o
    ekrandayız ve kendine yönlendiren bir satır göstermek boş bir
    döngü olurdu.
  */
  const erisilebilirEkranlar = MENU.filter(
    (m) =>
      m.anahtar !== "bugun" &&
      // Modul kapaliyken "yetkili oldugunuz ekranlar" listesi de canli calismayi gostermesin (F-LIV-05).
      ekranGorunur(m.anahtar) &&
      m.izin !== undefined &&
      (typeof m.izin === "string" ? izinVar(m.izin) : biriVarMi(ben.izinler, m.izin)),
  );

  /*
    ================================================================
    İZİNSİZ EKRANA GİDİLDİYSE — 403
    ================================================================
    Menü zaten izne göre süzülüyor, yani kullanıcı buraya MENÜDEN
    gelemez. Ama başka yollar var ve 04.09.2026'da bir tane daha
    açıldı: bildirimdeki "Kayda git" düğmesi.

    Bildirim, kullanıcının artık göremediği bir kayda işaret
    edebiliyor — rolü değişmiş olabilir. O durumda bugüne kadar
    ekran AÇILIYOR ve içindeki her sorgu tek tek 403 alıyordu:
    kullanıcı yarım çizilmiş, hata dolu bir ekran görüyordu.

    Kapıyı burada tutmak, her ekranın kendi kontrolünü yazmasından
    iyi: unutulacak tek bir yer var ve o da burası.

    NOT — bu bir GÜVENLİK sınırı DEĞİL. Asıl kontrol sunucuda ve
    orada duruyor; buradaki yalnızca kullanıcıya yarım bir ekran
    göstermemek için.
  */
  const aktifMenu = MENU.find((m) => m.anahtar === aktif);
  const ekranaErisim =
    !aktifMenu?.izin ||
    (typeof aktifMenu.izin === "string"
      ? izinVar(aktifMenu.izin)
      : biriVarMi(ben.izinler, aktifMenu.izin));

  if (!ekranaErisim) {
    return <Hata403 onBugun={() => setAktif("bugun")} />;
  }

  if (aktif === "mentorum" || aktif.startsWith("mentorum-")) {
    if (mentorumModul.isPending) return <p role="status">Mentörüm durumu yükleniyor…</p>;
    if (mentorumModul.isError)
      return (
        <Kart baslik="Mentörüm kullanılamıyor">
          <p>Modül kapalı veya durum bilgisi alınamadı.</p>
          <Buton onClick={() => void mentorumModul.refetch()}>Yeniden dene</Buton>
          <Buton gorunum="ikincil" onClick={() => setAktif("bugun")}>
            Anasayfaya dön
          </Buton>
        </Kart>
      );
  }

  return (
    <Cerceve>
      <Kabuk
        menu={kabukMenusu}
        gruplar={MENU_GRUPLARI}
        aktif={aktifAlan?.anahtar ?? ""}
        baslikIkonu={aktifAlan?.ikon}
        /*
          PROFIL BLOGU yalniz GORUNTU: ad ve rol ADI ekrana yaziliyor, hicbir dal buna
          bakmiyor (CLAUDE.md kural 1). Soyadi BUYUK harf — eski paneldeki yazim.
        */
        profil={
          profilim.data
            ? {
                ad: `${profilim.data.firstName} ${profilim.data.lastName.toLocaleUpperCase("tr-TR")}`,
                rol: profilim.data.roller[0],
              }
            : profilim.isError
              ? null
              : undefined
        }
        onCikis={() => cikis.mutate()}
        onSec={(alan) => {
          // Menu ALAN anahtari veriyor; alanin giris ekranina gidiliyor. Zaten
          // alanin icindeysek de giris ekranina donuyor (bos sekmeye takilmamak
          // icin tek belirleyici kural: alana basmak = alanin ilk ekrani).
          const hedef = alanlar.find((a) => a.anahtar === alan);
          if (hedef) ekranaGit(hedef.giris);
        }}
        altSekmeler={
          aktifAlan && aktifAlan.sekmeler.length > 1 && aktifAlan.sekmeler.includes(aktif) ? (
            <AlanSekmeleri
              sekmeler={aktifAlan.sekmeler.map((anahtar) => ({
                anahtar,
                etiket: ekranEtiketi(anahtar),
              }))}
              aktif={aktif}
              onSec={ekranaGit}
            />
          ) : undefined
        }
        // Baslik YALNIZ menu etiketi; ogrenci adi bandin icinde hap olarak (Kabuk `ogrenciAdi`) — "Ad — Konu Takibi" tekrari kalkti.
        baslik={baslik}
        ogrenciAdi={ogrenci?.ad}
        // UNİKOÇ Anasayfa'sinda baslik bandi yok (tarama-1 §3.1).
        baslikBandiGizli={aktif === "bugun" && !ogrenci}
        // F-NTF-09 — her ekranda AYNI YERDE.
        saginUstu={<BildirimZili onAc={() => setAktif("bildirimler")} />}
      >
        {/*
        ================================================================
        HATA SINIRI KABUĞUN İÇİNDE — 04.09.2026
        ================================================================
        Depoda hiç yoktu: bir bileşen render sırasında patlarsa React
        bütün ağacı söküyor ve kullanıcı BEYAZ BİR SAYFA görüyordu.

        Sınır kökü değil İÇERİĞİ sarıyor: menü ve üst bant ayakta
        kalıyor, yalnızca patlayan ekranın yerine hata sayfası
        çiziliyor. Kökü sarsaydık tek bir ekranın hatası bütün paneli
        kullanılamaz hâle getirirdi.

        `resetKey` ekran anahtarı: kullanıcı başka bir ekrana geçince
        sınır kendini topluyor. Toplanmasaydı bir ekranda alınan hata
        bütün gezinmeyi kilitler ve sayfa yenilemek gerekirdi.
      */}
        <HataSiniri resetKey={`${aktif}:${ogrenci?.id ?? ""}`}>
          {/*
        F-YED-22 — bant ANA EKRANDA. Yedekleme ekranina koysaydik
        yalnizca oraya bakan gorurdu; bandin amaci ise bakmayana
        soylemek.
      */}
          {aktif === "bugun" && !ogrenci && izinVar("sistem.yedek.yonet") && (
            <YedekBandi onGit={() => setAktif("yedek")} />
          )}

          {/*
        ================================================================
        G-AUT-02a — YEDEK KOD HARCANDI, KAÇ TANE KALDI
        ================================================================
        Kurtarma kodu ekranı "kalan kod sayınız girişten sonra ekranda
        gösterilecek" diye söz veriyor; sözü tutan yer burası.

        BANT GİRİŞ EKRANINDA DEĞİL, GİRİŞTEN SONRA: sayı ancak kod
        harcandıktan sonra biliniyor ve o an giriş ekranı çoktan
        kapanmış oluyor.

        Kapatılabiliyor ve kapatınca bir daha gelmiyor — oturum
        boyunca sürekli duran bir uyarı, üçüncü ekranda görünmez
        oluyor.
      */}
          {/*
        ================================================================
        G-AUT-01d — 2FA ZORLAMIYOR AMA UNUTTURMUYOR
        ================================================================
        04.09.2026'da 2FA zorunluluğu kaldırıldı (Emre: "isteyen
        açsın"). Zorunluluğu kaldırmak "sessizce vazgeçmek" olmamalı:
        hiçbir şey söylenmezse özellik fiilen ölür, çünkü kimse
        profilinde onu arayıp bulmaz.

        BANT GİRİŞİ ENGELLEMİYOR — tek farkı bu. Eski davranış
        kurulum ekranını zorunlu kılıyordu; bu yalnızca bir satır.

        Kapatılınca ON DÖRT GÜN çıkmıyor: her ekranda duran bir uyarı
        üçüncü ekranda görünmez oluyor ve gerçek uyarıları da
        beraberinde götürüyor. Erteleme tarayıcıda ve kullanıcıya
        bağlı tutuluyor (`uyari-erteleme.ts`); süre dolunca
        hatırlatma kendiliğinden geri geliyor — yani susturma
        kalıcıya dönüşmüyor.

        Öğrenci ve veliye gösterilmiyor: onlarda yöntem TOTP değil
        (şartname G-AUT-01 tablosu) ve bant, en çok kullanılan ekranı
        her gün daraltırdı.
      */}
          {ikiAsamaHatirlat && (
            <NotKutusu ton="uyari" className="mb-4 items-center">
              <span className="flex flex-wrap items-center gap-x-2 gap-y-1">
                {/*
                  TELEFONDA TEK SATIR — UI/UX Dalga 1 (M-01). 390 px'te bant
                  ~100 px tutuyor ve ilk is karti 372. px'e itiliyordu; bant
                  HER ekranda. Gerekce cumlesi genis ekranda kaliyor, telefonda
                  durum + iki dugme yetiyor (gerekce Hesabim'daki kartta).
                */}
                <strong className="md:hidden">2 adımlı doğrulama kapalı</strong>
                <span className="max-md:hidden">
                  Hesabınızda <strong>iki adımlı doğrulama kapalı</strong>. Şifreniz ele geçse bile
                  hesabınıza girilmesini engeller.
                </span>
                {/*
                  ================================================================
                  DOKUNMA HEDEFİ — TELEFONDA ÖLÇÜLDÜ, 19×21 px ÇIKTI
                  ================================================================
                  Bu ikisi çıplak `<button>`dı: yalnızca altı çizili metin,
                  ne dolgu ne yükseklik. 375 px'te ölçüldü: **"Kur" 19,4 ×
                  20,8 px.** Proje kuralı 44 px (`min-h-dokunma`,
                  03-kod-standartlari.md), WCAG 2.5.8'in tabanı 24×24 —
                  ikisinin de altında.

                  07.09.2026 — YÜKSEKLİK DÜZELMİŞ, GENİŞLİK KALMIŞTI:
                  390 px'te "Kur" **27 × 44** ölçüldü. `min-h-dokunma`
                  eklenmiş, `min-w-dokunma` unutulmuştu; üç harflik bir
                  düğmede genişlik metinden geliyor ve 44'e hiç ulaşmıyor.
                  WCAG 2.5.8'i geçiyordu ama projenin kendi 44×44 kuralını
                  geçmiyordu. `Buton` bileşenine bu koruma eklenmişti —
                  bu ikisi çıplak `<button>` olduğu için o düzeltmenin
                  dışında kalmışlar.

                  "Satır içi bağlantı" istisnası burada GEÇERSİZ: ata öge
                  bir `flex` satırı ve düğmelerin metin kardeşi yok, yani
                  cümlenin içinde akan bir bağlantı değiller — yan yana
                  duran iki denetim.

                  Ve hangi düğme olduğu önemli: "Kur" iki adımlı doğrulamayı
                  başlatıyor. Telefonda ıskalanan bir güvenlik düğmesi,
                  ıskalandığı için ertelenen bir güvenlik önlemidir.

                  `md:min-h-0` kırılımı `Kabuk.tsx`teki gerekçenin aynısı:
                  44 px bir DOKUNMA gereği; farenin olduğu ekranda aynı
                  yüksekliği zorlamak bandı gereksiz kalınlaştırırdı.
                */}
                <button
                  type="button"
                  onClick={() => setAktif("hesap")}
                  className="min-h-dokunma min-w-dokunma -my-2 px-1 underline underline-offset-2 md:my-0 md:min-h-0 md:min-w-0"
                >
                  Kur
                </button>
                {/*
                  Yazma başarısız olsa da bant kapanıyor: kullanıcı
                  "şimdi değil" dedi ve ekranda gördüğü sonuç bu
                  olmalı. Yazamamanın bedeli ertelemenin bu sekmeyle
                  sınırlı kalması — kullanıcıya söylenecek bir şey
                  değil, çünkü yapabileceği bir şey yok.
                */}
                <button
                  type="button"
                  onClick={() => {
                    ertele(IKI_ASAMA_UYARISI, ben?.userId ?? null);
                    setIkiAsamaKapatildi(true);
                  }}
                  className="min-h-dokunma min-w-dokunma -my-2 px-1 underline underline-offset-2 md:my-0 md:min-h-0 md:min-w-0"
                >
                  {/*
                    Telefonda "Sonra": "Şimdi değil" ikinci satıra düşüp bandı iki
                    satıra çıkarıyordu (GCP 390 px ölçümü, 86 px). Erişilebilir ad
                    DEĞİŞMİYOR — görünür kısa etiket aria-hidden, uzun ad sr-only.
                  */}
                  <span aria-hidden="true" className="md:hidden">
                    Sonra
                  </span>
                  <span className="max-md:sr-only">Şimdi değil</span>
                </button>
              </span>
            </NotKutusu>
          )}

          {yedekKodUyarisi !== null && (
            <NotKutusu
              ton={yedekKodUyarisi <= 3 ? "uyari" : "bilgi"}
              duyur
              className="mb-4 items-center"
            >
              <span className="flex flex-wrap items-center gap-x-2 gap-y-1">
                <span>
                  Bir yedek kod harcandı.{" "}
                  <strong>
                    {yedekKodUyarisi === 0
                      ? "Hiç yedek kodunuz kalmadı"
                      : `${yedekKodUyarisi} kod kaldı`}
                  </strong>
                  . Kodlar bitince hesabı yalnızca yönetici açabilir.
                </span>
                <button
                  type="button"
                  onClick={() => setYedekKodUyarisi(null)}
                  className="underline underline-offset-2"
                >
                  Anladım
                </button>
              </span>
            </NotKutusu>
          )}

          {/*
        ================================================================
        ACILIS EKRANI ROLE GORE DALLANMIYOR — HER IKISI DE CIZILIYOR
        ================================================================
        `IsListesi` uzman OLMAYAN birine `null` donuyor, `YoneticiBugun`
        satirlari ise 403 alan kaynaklari zaten disarida birakiyor.
        Yani ikisi de kendi kitlesini KENDISI buluyor ve burada rol
        adina gore bir `if` yazmak gerekmiyor.
        
        Rol adina dallanmak, ozel bir rol tanimlandigi gun (F-ROL-04)
        hicbir sey gormeyen bir acilis ekrani uretirdi.
      */}
          {aktif === "bugun" &&
            !ogrenci &&
            (bugunBos ? (
              /*
            ================================================================
            HİÇBİR KAYNAĞA ERİŞMEYEN KULLANICIDA SAYFA BOMBOŞ AÇILIYORDU
            ================================================================
            İki bileşen de kendi kitlesini kendisi buluyor ve bulamayınca
            SESSİZCE çekiliyor — ikisi de doğru davranıyor. Ama ikisi
            birden çekilince ortaya hiçbir şey söylemeyen bir sayfa
            çıkıyordu.

            Boş bir ekran "sistem bozuk" diye okunuyor. Oysa durum bir
            arıza değil: kullanıcının rolü bu ekranın özetlediği
            kaynakların hiçbirini kapsamıyor.

            KOŞUL BURADA HESAPLANIYOR, çocuklara sorulmuyor: bir bileşenin
            `null` döndüğünü üst kattan anlamanın yolu yok ve olsaydı da
            "hiçbir şey çizmedi" ile "yükleniyor" birbirine karışırdı.

            Menü zaten izne göre süzülüyor; buradaki liste kullanıcının
            GERÇEKTEN gidebileceği yerleri gösteriyor, sabit bir metin
            değil — rol değiştiğinde kendiliğinden değişiyor.
          */
              <Kart
                baslik="Bu ekran rolünüzde özet göstermiyor"
                aciklama="Bugün ekranı onay kuyruğu, tahsilat, destek talebi, izin ve aday takibini özetler. Rolünüz bu kaynakların hiçbirini kapsamadığı için özetlenecek bir şey yok — bu bir hata değil."
              >
                {erisilebilirEkranlar.length > 0 ? (
                  <div className="flex flex-col gap-2">
                    <p className="text-notr-700 text-sm">Yetkili olduğunuz ekranlar:</p>
                    <ul className="flex flex-col gap-2">
                      {erisilebilirEkranlar.map((m) => (
                        <li key={m.anahtar}>
                          <SatirDugmesi onClick={() => setAktif(m.anahtar)}>
                            <Ikon ad={m.ikon} className="text-notr-600" />
                            <SatirMetni baslik={m.etiket} altBaslik={m.bolum} />
                          </SatirDugmesi>
                        </li>
                      ))}
                    </ul>
                  </div>
                ) : (
                  <p className="text-notr-700 text-sm">
                    Hesabınıza henüz hiçbir ekran yetkisi tanımlanmamış. Kurum yöneticinize
                    başvurun.
                  </p>
                )}
              </Kart>
            ) : (
              <>
                {/*
                  BEKLEYENLER KUTUSU — UI/UX Dalga 2 (M3). Uzmanın (koçun) ana
                  ekranı iş listesi; bekleyen onay/talep/izin/mesaj tek satırlık
                  kutuda ÜSTTE. Uzman OLMAYAN yönetici kendi sayı kartlarını
                  (`YoneticiBugun`) görmeye devam ediyor: ikisi aynı kaynakları
                  paylaşıyor, aynı ekranda ikisini birden çizmek aynı sayıyı iki
                  kez söylemek olurdu.
                */}
                {ben.uzmanMi && <Bekleyenler onEkranSec={setAktif} izinler={ben.izinler} />}
                <IsListesi
                  izinler={ben.izinler}
                  uzmanMi={ben.uzmanMi}
                  onOgrenciSec={(id, ad, tur) => {
                    setOgrenci({ id, ad });
                    setAktif(IS_TURU_EKRANI[tur] ?? "program");
                  }}
                />
                {!ben.uzmanMi && <YoneticiBugun onEkranSec={setAktif} izinler={ben.izinler} />}
              </>
            ))}

          {aktif === "program" &&
            (ogrenci ? (
              <Program
                ogrenciId={ogrenci.id}
                ogrenciAdi={ogrenci.ad}
                onOgrenciDosyasi={
                  gorunurMenu.some((m) => m.anahtar === "ogrenci-360")
                    ? () => setAktif("ogrenci-360")
                    : undefined
                }
                onGeri={() => {
                  setOgrenci(null);
                  setAktif("bugun");
                }}
              />
            ) : (
              <ProgramGirisi
                onSec={(id, ad) => setOgrenci({ id, ad })}
                onIsListesi={() => setAktif("bugun")}
              />
            ))}

          {aktif === "raporlar" &&
            (ogrenci ? (
              <Raporlar
                key={`${ogrenci.id}-${raporDonemiBu?.bas ?? ""}`}
                ogrenciId={ogrenci.id}
                ogrenciAdi={ogrenci.ad}
                onDoldurulmusDonem={raporDonemiBu}
                onGeri={() => {
                  setRaporDonemi(null);
                  setOgrenci(null);
                  setAktif("bugun");
                }}
              />
            ) : (
              <div className="flex flex-col gap-6">
                {(izinVar("rapor.veli.olustur") || izinVar("rapor.veli.onayla")) && (
                  <EksikVeliRaporlari
                    onSec={(e) => {
                      setRaporDonemi({
                        ogrenciId: e.ogrenciId,
                        bas: e.haftaBasi.slice(0, 10),
                        bit: e.haftaSonu.slice(0, 10),
                      });
                      setOgrenci({ id: e.ogrenciId, ad: e.ogrenciAdi });
                    }}
                  />
                )}
                <OgrenciSecici
                  baslik="Kimin raporu?"
                  aciklama="Veli raporu bir öğrenciye ait; önce kimin raporlarına bakacağınızı seçin."
                  onSec={(id, ad) => {
                    setRaporDonemi(null);
                    setOgrenci({ id, ad });
                  }}
                  onIsListesi={() => setAktif("bugun")}
                />
              </div>
            ))}

          {/* Onay kuyrugu ogrenci secimi ISTEMIYOR: soru "kim benden bir
          sey bekliyor", "bu ogrencide ne var" degil. */}
          {aktif === "denemeler" &&
            (ogrenci ? (
              <Denemeler
                ogrenciId={ogrenci.id}
                ogrenciAdi={ogrenci.ad}
                onGeri={() => {
                  setOgrenci(null);
                  setAktif("bugun");
                }}
                /*
              TODO(Faz 4 kalani): secilen konular program editorune
              aktarilacak. Su an ekran onerileri gosteriyor ve secim
              yaptiriyor; aktarim ucu (`POST /program/:id/gorevler`)
              zaten var, baglantisi program ekraniyla birlikte
              yazilacak. Buraya YANLIS bir baglanti koymaktansa
              acikca bos birakiyorum.
            */
                onTelafiyeAktar={undefined}
                onOgrenciSec={(id, ad) => setOgrenci({ id, ad })}
                onTumDenemeler={() => setOgrenci(null)}
              />
            ) : (
              /* Sürüm 9a L2: UNİKOÇ gibi açılışta deneme tablosu; öğrenci filtre kartında. */
              <DenemeGirisi
                listeGorebilir={izinVar("deneme.sinav.yonet") || izinVar("deneme.sonuc.gir")}
                yonetebilir={izinVar("deneme.sinav.yonet")}
                duzenleyebilir={izinVar("deneme.sinav.duzenle")}
                atayabilir={izinVar("deneme.atama.yonet")}
                onOgrenciSec={(id, ad) => setOgrenci({ id, ad })}
              />
            ))}

          {aktif === "onay" && (
            <OnayKuyrugu
              raporOnaylayabilir={izinVar("rapor.veli.onayla")}
              genelOnaylayabilir={izinVar("program.hafta.onayla")}
            />
          )}

          {aktif === "mentorum" && <MentorumYonetim izinler={ben.izinler} />}
          {aktif === "mentorum-risk" && (
            <MentorumRisk
              izinler={ben.izinler}
              onKayitAc={(ogrenciId) => {
                setMentorumOgrenciId(ogrenciId);
                setAktif("mentorum-kayitlar");
              }}
            />
          )}
          {aktif === "mentorum-kayitlar" && (
            <MentorumKayitlar
              key={mentorumOgrenciId}
              izinler={ben.izinler}
              ilkOgrenciId={mentorumOgrenciId}
            />
          )}
          {aktif === "adaylar" && <Adaylar />}

          {aktif === "takvim" && <Takvim izinler={ben.izinler} />}

          {aktif === "operasyon" && <Operasyon />}

          {aktif === "notlarim" && <Notlarim />}

          {aktif === "talepler" && <Talepler acilanEkran={oncekiEkran ?? undefined} />}

          {aktif === "gorusmeler" && <Gorusmeler />}

          {aktif === "finans" && <Finans />}

          {aktif === "risk" && (
            <YenilemeRiski
              onOgrenciSec={(id) => {
                // Risk listesinden dogrudan ogrenciye gecis: F-ANL-09
                // "ogrenci secme ekranina donulmez" ilkesi burada da
                // gecerli. Ad henuz bilinmiyor, numara gosteriliyor.
                setOgrenci({ id, ad: "Öğrenci" });
                setAktif("program");
              }}
            />
          )}

          {aktif === "loglar" && <Loglar />}

          {aktif === "roller" && <Roller />}
          {aktif === "gorunum" && <Gorunum />}
          {aktif === "sablonlar" && (
            <BildirimSablonlari arsivleyebilir={izinVar("sistem.bildirim.arsivle")} />
          )}
          {aktif === "entegrasyonlar" && <Entegrasyonlar />}
          {(aktif === "oyunlastirma" ||
            aktif === "odul-cark" ||
            aktif === "odul-magaza" ||
            aktif === "odul-siparis") && (
            <OyunYonetimi
              key={aktif}
              ilkBolum={ODUL_ILK_BOLUM[aktif]}
              modulYonetebilir={izinVar("sistem.ayar.duzenle")}
              kuralDuzenleyebilir={izinVar("oyun.kural.duzenle")}
              duzeltebilir={izinVar("oyun.puan.duzelt")}
              genelGorebilir={izinVar("oyun.kural.goruntule")}
              urunYonetebilir={izinVar("oyun.urun.yonet")}
              siparisYonetebilir={izinVar("oyun.siparis.yonet")}
              kagitOnayVerebilir={izinVar("oyun.siparis.kagit_onayla")}
              carkGorebilir={izinVar("oyun.cark.yonet")}
              carkYonetebilir={izinVar("oyun.cark.yonet")}
              liderlikGorebilir={izinVar("oyun.liderlik.goruntule")}
              hareketGorebilir={izinVar("oyun.hareket.goruntule")}
              siparisGorebilir={izinVar("oyun.siparis.goruntule")}
            />
          )}

          {aktif === "canli-calisma" && (
            <CanliCalisma
              goruntule={izinVar("canli.izleme.goruntule")}
              yonetebilir={izinVar("canli.izleme.yonet")}
              onBilgiAc={() => setAktif("canli-bilgilendirme")}
              onOgrenciAc={
                gorunurMenu.some((m) => m.anahtar === "ogrenci-360")
                  ? (id, ad) => {
                      setOgrenci({ id, ad });
                      setAktif("ogrenci-360");
                    }
                  : undefined
              }
            />
          )}
          {aktif === "canli-bilgilendirme" && <CanliBilgilendirme />}

          {aktif === "kvkk" && (
            <Kvkk
              metinYonetebilir={izinVar("kvkk.metin.yonet")}
              kagitKaydedebilir={ben.izinler["kvkk.riza.kagit_kaydet"] === "ALL"}
              rizaYonetebilir={izinVar("kvkk.riza.yonet")}
              sonuclandirabilir={ben.izinler["kvkk.basvuru.sonuclandir"] === "ALL"}
              saklamaYonetebilir={izinVar("sistem.kayit.kalici_sil")}
            />
          )}

          {aktif === "abonelik" &&
            (ogrenci ? (
              <AbonelikKarti ogrenciId={ogrenci.id} acabilir={izinVar("finans.tahsilat.isle")} />
            ) : (
              <OgrenciSecici
                baslik="Kimin aboneliği?"
                aciklama="Abonelik ve ödeme planı bir öğrenciye ait; önce kimin kaydına bakacağınızı seçin."
                onSec={(id, ad) => setOgrenci({ id, ad })}
                onIsListesi={() => setAktif("bugun")}
              />
            ))}

          {aktif === "personel-360" &&
            (personel ? (
              <Personel360
                personelId={personel.id}
                personelAdi={personel.ad}
                /* Ham izin haritasi OLDUGU GIBI; daraltma kabukta tek yerde. */
                izinler={ben.izinler}
                onPersonelDegistir={() => setPersonel(null)}
              />
            ) : (
              <PersonelSecici onSec={(id, ad) => setPersonel({ id, ad })} />
            ))}

          {aktif === "mesajlar" && <Mesajlar />}

          {aktif === "mesaj-denetim" && <MesajDenetim />}

          {aktif === "sistem" && (
            <SistemSagligi ayarDuzenleyebilir={izinVar("sistem.ayar.duzenle")} />
          )}

          {aktif === "guvenlik" && <Guvenlik onGit={setAktif} />}

          {aktif === "yedek" && <Yedek />}

          {aktif === "geri-yukleme" && <GeriYukleme />}

          {aktif === "kurtarma" && <KurtarmaYordami />}

          {/*
        Yardim acilirken BULUNULAN ekran iletiliyor (F-HLP-12).
        Iletilmeseydi kullanici, aradigini bulmak icin kategorilerde
        gezinmek zorunda kalirdi — oysa hangi ekrandan geldigini
        sistem zaten biliyor.
      */}
          {aktif === "yardim" && (
            <Yardim
              acilanEkran={oncekiEkran ?? undefined}
              onEkranaGit={ekranaGit}
              gidilebilir={ekranGorunur}
            />
          )}

          {aktif === "teknik" && <TeknikKonsol />}
          {aktif === "etkinlik" && <Etkinlik />}
          {aktif === "hesap" && <Hesabim />}

          {/*
        Tur EN SONDA ciziliyor: karartma tabakasi butun ekranin
        uzerinde olmali. Menu vurgusu `data-menu` + `stil.css` ile.
      */}
          <Tur />

          {aktif === "kocluk" &&
            (ogrenci ? (
              <KoclukGorusmeleri
                ogrenciId={ogrenci.id}
                ogrenciAdi={ogrenci.ad}
                notYazabilir={izinVar("gorusme.not_korumali.yaz")}
                notOkuyabilir={izinVar("gorusme.not_korumali.oku")}
              />
            ) : (
              <OgrenciSecici
                baslik="Kimin görüşmeleri?"
                aciklama="Koçluk görüşmeleri bir öğrenciye ait; önce kimin kaydına bakacağınızı seçin."
                onSec={(id, ad) => setOgrenci({ id, ad })}
                onIsListesi={() => setAktif("bugun")}
              />
            ))}

          {aktif === "ogrenci-360" &&
            (ogrenci ? (
              <Ogrenci360
                ogrenciId={ogrenci.id}
                ogrenciAdi={ogrenci.ad}
                /*
                  Ham izin haritasi OLDUGU GIBI veriliyor; daraltma
                  kabukta tek yerde oluyor. Burada tek tek `"x" in
                  ben.izinler` yazsaydik on bir sekme icin on bir elle
                  yazilmis dizgi olurdu ve hicbiri yazim hatasina karsi
                  korunmazdi — panelde bugun tam olarak boyle on bes
                  satir var.
                */
                izinler={ben.izinler}
                onOgrenciDegistir={() => setOgrenci(null)}
              />
            ) : (
              <OgrenciSecici
                baslik="Hangi öğrenci?"
                aciklama="360° ekranı tek öğrencinin bütün kaydını tek yerde gösterir; önce kimin kaydına bakacağınızı seçin."
                onSec={(id, ad) => setOgrenci({ id, ad })}
                onIsListesi={() => setAktif("bugun")}
              />
            ))}

          {aktif === "dosya" &&
            (ogrenci ? (
              <KarneDosyaSekmesi key={ogrenci.id} ogrenciId={ogrenci.id}>
                <OgrenciDosyasi
                  ogrenciId={ogrenci.id}
                  ogrenciAdi={ogrenci.ad}
                  veliBaglayabilir={izinVar("kisi.veli.bagla")}
                  veliKaldirabilir={izinVar("kisi.veli.kaldir")}
                  duzenleyebilir={izinVar("kisi.ogrenci.duzenle")}
                />
              </KarneDosyaSekmesi>
            ) : (
              <OgrenciSecici
                baslik="Kimin dosyası?"
                aciklama="Veli, uzman ataması ve dosyalar bir öğrenciye ait; önce kimin kaydına bakacağınızı seçin."
                onSec={(id, ad) => setOgrenci({ id, ad })}
                onIsListesi={() => setAktif("bugun")}
              />
            ))}

          {aktif === "hata-defteri" &&
            (ogrenci ? (
              <HataDefteri ogrenciId={ogrenci.id} ogrenciAdi={ogrenci.ad} />
            ) : (
              <OgrenciSecici
                baslik="Kimin hata defteri?"
                aciklama="Hata defteri bir öğrenciye ait; önce kimin kaydına bakacağınızı seçin."
                onSec={(id, ad) => setOgrenci({ id, ad })}
                onIsListesi={() => setAktif("bugun")}
              />
            ))}

          {/* Sürüm 9a L2: UNİKOÇ Konu Takip — öğrenci ekranın filtre kartında seçilir. */}
          {aktif === "konular" && (
            <KonuIlerlemesi
              ogrenciId={ogrenci?.id ?? null}
              ogrenciAdi={ogrenci?.ad}
              onOgrenciSec={(id, ad) => setOgrenci({ id, ad })}
            />
          )}

          {aktif === "ogrenci-kaynak" &&
            (ogrenci ? (
              <OgrenciKaynaklari
                ogrenciId={ogrenci.id}
                ogrenciAdi={ogrenci.ad}
                duzenleyebilir={izinVar("akademik.kaynak.ogrenci_duzenle")}
                kaldirabilir={izinVar("akademik.kaynak.ogrenci_kaldir")}
              />
            ) : (
              <OgrenciSecici
                baslik="Kimin kaynak listesi?"
                aciklama="Kaynak listesi bir öğrenciye ait; önce kimin kaydına bakacağınızı seçin."
                onSec={(id, ad) => setOgrenci({ id, ad })}
                onIsListesi={() => setAktif("bugun")}
              />
            ))}

          {aktif === "haftalik-analiz" &&
            (ogrenci ? (
              <HaftalikAnaliz
                ogrenciId={ogrenci.id}
                ogrenciAdi={ogrenci.ad}
                onGeri={() => {
                  setOgrenci(null);
                  setAktif("bugun");
                }}
              />
            ) : (
              <OgrenciSecici
                baslik="Kimin analizi?"
                aciklama="Haftalık analiz bir öğrenciye ait; önce kimin kaydına bakacağınızı seçin."
                onSec={(id, ad) => setOgrenci({ id, ad })}
                onIsListesi={() => setAktif("bugun")}
              />
            ))}

          {/* Sürüm 9a L2: UNİKOÇ gibi açılışta tablo; öğrenci ekranın filtre kartında seçilir. */}
          {aktif === "ogrenci-planlari" && (
            <OgrenciPlanlari
              ogrenciId={ogrenci?.id ?? null}
              ogrenciAdi={ogrenci?.ad}
              duzenleyebilir={izinVar("takvim.mesguliyet.yonet")}
              onOgrenciSec={(id, ad) => setOgrenci({ id, ad })}
              onGeri={() => {
                setOgrenci(null);
                setAktif("bugun");
              }}
            />
          )}

          {aktif === "konu-plani" &&
            (ogrenci ? (
              <KonuPlani
                ogrenciId={ogrenci.id}
                ogrenciAdi={ogrenci.ad}
                onGeri={() => {
                  setOgrenci(null);
                  setAktif("bugun");
                }}
              />
            ) : (
              <OgrenciSecici
                baslik="Kimin konu planı?"
                aciklama="Konu bitirme takvimi bir öğrenciye ait; önce kimin kaydına bakacağınızı seçin."
                onSec={(id, ad) => setOgrenci({ id, ad })}
                onIsListesi={() => setAktif("bugun")}
              />
            ))}

          {aktif === "bildirimler" && (
            <Bildirimler
              onGit={(linkUrl) => {
                /*
              ================================================================
              "KAYDA GİT" BUGÜNE KADAR HİÇ ÇALIŞMIYORDU
              ================================================================
              `Bildirimler` bileşeni `onGit` propunu kabul ediyordu ve
              buradan HİÇ VERİLMİYORDU: düğme çiziliyor, basılıyor ve
              hiçbir şey olmuyordu.

              Eşleme saf bir modülde (`bildirim-yonlendirme.ts`) ve
              testli. Tanınmayan yol `null` dönüyor; o durumda düğme
              zaten hiç çizilmiyor (bileşenin kendi kararı).
            */
                const hedef = bildirimHedefi(linkUrl);
                if (hedef === null) return;
                if (hedef.ogrenciId) {
                  /*
                ÖĞRENCİ ADI BURADA ÇÖZÜLMÜYOR. Liste elimizde değil
                ve ikinci bir istek atmak, bildirime tıklamayı
                yavaşlatırdı. Ekran öğrenci seçiliyken adı zaten
                kendi sorgusundan okuyor; buradaki ad geçici.
              */
                  setOgrenci({ id: hedef.ogrenciId, ad: "Öğrenci" });
                }
                setAktif(hedef.ekran);
              }}
            />
          )}

          {aktif === "deneme-tanim" && (
            <DenemeTanim
              yonetebilir={izinVar("deneme.sinav.yonet")}
              duzenleyebilir={izinVar("deneme.sinav.duzenle")}
              sonucGirebilir={izinVar("deneme.sonuc.gir")}
              atayabilir={izinVar("deneme.atama.yonet")}
            />
          )}

          {aktif === "mufredat" && (
            <Mufredat duzenleyebilir={izinVar("akademik.mufredat.duzenle")} />
          )}

          {aktif === "kaynaklar" && <KaynakHavuzu yonetebilir={izinVar("akademik.kaynak.yonet")} />}

          {aktif === "personel" && (
            <Personel yonetebilir={izinVar("kisi.personel.yonet")} benimId={ben.userId} />
          )}

          {aktif === "ogrenciler" && (
            <Ogrenciler
              ekleyebilir={izinVar("kisi.ogrenci.olustur")}
              analizGorebilir={izinVar("analiz.ogrenci.goruntule")}
              muvafakatKaydedebilir={izinVar("kvkk.muvafakat.kaydet")}
              durumDegistirebilir={izinVar("kisi.ogrenci.durum_degistir")}
              onVeliEkle={
                izinVar("kisi.veli.bagla") && gorunurMenu.some((m) => m.anahtar === "dosya")
                  ? (id, ad) => {
                      setOgrenci({ id, ad });
                      setAktif("dosya");
                    }
                  : undefined
              }
              onProfilAc={
                gorunurMenu.some((m) => m.anahtar === "ogrenci-360")
                  ? (id, ad) => {
                      setOgrenci({ id, ad });
                      setAktif("ogrenci-360");
                    }
                  : undefined
              }
              onOgrenciSec={(id, ad) => {
                setOgrenci({ id, ad });
                setAktif("program");
              }}
            />
          )}

          {!YAZILAN_EKRANLAR.includes(aktif) && <Hazirlaniyor baslik={baslik} />}
        </HataSiniri>
      </Kabuk>
    </Cerceve>
  );
}

/**
 * GORUNUM SERIDI HER IKI DALI DA SARIYOR — F-AUTH-07
 *
 * ================================================================
 * SERIT VELI PORTALINDA DA GEREKLI
 * ================================================================
 * Gorunum modunda `ben` HEDEFIN kimligini donduruyor. Yonetici bir
 * VELININ gorunumune gectiginde uygulama veli dalini ciziyor — yani
 * serit yalnizca personel dalina konsaydi, tam da en cok gerektigi
 * yerde kaybolurdu: kullanici kendini bir anda veli portalinde
 * bulur ve neden oldugunu soyleyen hicbir sey olmazdi.
 */
function Cerceve({ children }: { children: ReactNode }) {
  return (
    <div className="min-h-screen">
      <GorunumSeridi />
      {children}
    </div>
  );
}

function Hazirlaniyor({ baslik }: { baslik: string }) {
  return (
    <BosDurum
      ikon="yeni"
      baslik={`${baslik} ekranı henüz hazır değil`}
      /*
        "SUNUCU TARAFI HAZIR" DEMİYORUZ ARTIK.
        ================================================================
        Cümle koşulsuzdu ve bu ekran GELECEKTEKİ bir menü girdisi için
        var: bugün `MENU` ile `YAZILAN_EKRANLAR` birebir eşit (41=41, 04.10.2026),
        yani buraya ancak YENİ bir girdi eklendiğinde düşülüyor. O yeni
        ekranın sunucu tarafının hazır olup olmadığını burası bilemez —
        ama "hazır" diye yazıyordu.

        Bu, bugün gün boyu yakalanan sınıfın gelecekteki hâli: kod bir
        şeyi bilmediği hâlde iddia ediyor. Ölçemediğimiz şeyi
        söylemiyoruz.
      */
      aciklama="Bu ekran henüz yazılmadı. Menüde göründüğü hâlde açılmıyorsa sebebi bu — bir arıza değil."
    />
  );
}
